// English copy. Falls back to zh for any missing key (see i18n/index.mjs).
export default {
  'app.title': 'Dev Coordinator',
  'app.langToggle': '中',

  // AppShell / account menu
  'shell.nav.docs': 'Docs',
  'shell.nav.submit': 'Submit Ticket',
  'shell.nav.myTickets': 'My Tickets',
  'shell.nav.admin': 'Admin',
  'shell.nav.approvals': 'Approvals',
  'shell.nav.workItems': 'Work items',
  'shell.nav.reports': 'Reports',
  'shell.nav.workHours': 'Work hours',
  'shell.nav.help': 'Help',
  // SB-151: aria-label / tooltip of the per-page ? button (components/HelpLink.jsx).
  // It points at the matching manual section - the label says where it goes.
  'help.link': 'Open the manual section for this',
  'shell.nav.open': 'Open navigation',
  'shell.nav.title': 'Navigation',
  // Batch 110: the top-left mark is now a traffic-light glyph (landscape / portrait).
  // Retires `shell.brand.short` ("DC") - the emoji replaced it.
  // An emoji is not a name: screen readers must hear the product name, hence the
  // separate aria-label.
  'shell.brand.aria': 'Dev Coordinator (home mark)',
  'shell.brand.tipDismiss': 'Tap again to dismiss',
  // ── SB-034 work hours (member surface) ──
  'work.title': 'Work hours',
  'work.subtitle': 'Log your own hours. The entry window spans {days} days centred on today (timezone: {tz}).',
  'work.today': 'today',
  'work.noRight': 'Your job post does not carry the log_work_hours right.',
  'work.addTitle': 'Log hours · {day}',
  'work.field.backlog': 'Work item',
  'work.field.hours': 'Hours',
  'work.field.hours.helper': 'in 0.5-hour steps',
  'work.field.note': 'Note (optional)',
  'work.action.log': 'Log',
  'work.action.reverse': 'Reverse',
  'work.logged': 'Logged.',
  'work.reversed': 'Reversed.',
  'work.noBacklogs': 'No work item in this project group can receive hours (only to-do / in-progress items can).',
  'work.dayTotal': '{used} logged that day / {cap} cap',
  'work.rowsTitle': 'Entries for {day}',
  'work.noRows': 'No entries for that day yet.',
  'work.col.backlog': 'Work item',
  'work.col.hours': 'Duration',
  'work.col.status': 'Status',
  'work.col.actions': 'Actions',
  'work.status.planned': 'Planned',
  'work.status.invested': 'Invested',
  'work.status.migrated': 'Migrated',
  'work.status.released': 'Released',
  'work.status.friction': 'Friction',
  'work.reversalRow': 'reversal',
  'work.reverse.title': 'Reverse hours',
  'work.reverse.desc': 'Invested hours cannot be edited in place; a reversal entry is appended to offset them (it may be less than the original).',
  'work.reverse.hours': 'Hours to reverse',
  'work.reverse.reason': 'Reason (optional)',
  'work.error.pickBacklog': 'Choose a work item first.',
  'work.error.halfHour': 'Duration must be a positive multiple of 0.5 hours.',
  'work.error.generic': 'The operation failed; please retry.',
  // ── Batch 84: R-08 edit/delete of planned hours (owner only, before the day) ──
  'work.action.edit': 'Edit',
  'work.action.delete': 'Delete',
  'work.edit.title': 'Edit planned hours',
  'work.edit.desc': 'Planned hours can be changed until the day arrives. The original entry is marked released and kept for the record; a new entry replaces it — the change stays visible in the ledger.',
  'work.edit.day': 'Move to day',
  'work.edit.hours': 'New duration (hours)',
  'work.edited': 'Updated.',
  'work.delete.title': 'Delete planned hours',
  'work.delete.desc': 'This plan will stop counting toward any total. The entry itself is not erased: it is marked released with an audit trail (work-hour entries are never physically deleted).',
  'work.deleted': 'Deleted.',
  'work.edit.error.noChange': 'Nothing changed.',
  'work.edit.error.day': 'Pick a day.',
  'work.edit.error.noRow': 'The entry to edit is gone; reload and try again.',
  'work.error.alreadyInvested': 'These hours are already invested and can no longer be edited or deleted — an invested entry is corrected by appending a reversal (R-36).',
  'work.error.planDue': 'The planned day has arrived: the entry auto-converts to invested at any moment, so it can no longer be edited or deleted. Once invested, correct it with a reversal.',
  'work.error.notPlanned': 'This entry is no longer planned (released / migrated / moved to friction) — there is nothing left to edit or delete.',
  'work.error.gone': 'No such entry, or it is not yours. Reload and try again.',
  // ── Batch 88: markdown rendering of bodies, plus the show-source escape hatch ──
  // ── Batch 90: the repository's public clone URL and how to use a credential ──
  'admin.repos.clone.title': 'Public clone URL (this is the one to hand to a collaborator)',
  'admin.repos.clone.howto': 'Credentials are issued per person, per repository on the Git access control page; the token is shown once and can be revoked at any time. Put the username and token into the command below:',
  'admin.repos.clone.noBase': 'This stage has no public address configured (PUBLIC_BASE_URL), so no shareable clone URL can be produced. That is normal in the local posture.',
  'body.showSource': 'Show source',
  'body.showRendered': 'Render as markdown',
  'submit.bodyIsPlainText': 'Show this body as plain text (no markdown rendering)',
  'submit.bodyIsPlainText.hint': 'Bodies render as markdown by default. Tick this if the # * _ characters in yours are not meant as formatting.',
  'backlog.translationPending': 'Translation pending',
  'backlog.translationStale': 'Translation outdated (source changed)',
  'backlog.translationPendingHint': 'No {lang} translation yet — showing the source language.',
  'backlog.edit': 'Edit',
  'backlog.editSaved': 'Saved.',
  'shell.account.jobPost': 'Job post',
  'shell.account.admin': 'Admin',
  'shell.group.title': 'Project group',
  // Batch 102: accessible name / tooltip for the toolbar chip and drawer header.
  'shell.group.aria': 'Current project group: {name}',
  'shell.group.switch': 'Click to switch project group',
  'shell.account.editNickname': 'Edit nickname',
  'shell.account.logout': 'Sign out',
  'shell.nick.title': 'Edit nickname',
  'shell.nick.label': 'Nickname',
  'shell.nick.helper': 'Leave empty to show your email. Up to 80 characters.',
  'shell.nick.error': 'Failed to save the nickname; please retry.',

  // Login page
  'login.title': 'Sign in to Dev Coordinator',
  'login.subtitle': 'Invited collaborators only. Use your invited email to sign in.',
  'login.tab.code': 'Login code',
  'login.tab.password': 'Password',
  'login.field.email': 'Email',
  'login.field.code': 'Login code',
  'login.field.password': 'Password',
  'login.action.sendCode': 'Send code',
  'login.action.resendIn': 'Resend in {s}s',
  'login.action.login': 'Sign in',
  'login.hint.codeSent': 'If the email is valid, a login code has been sent. Check your inbox.',
  'login.hint.codeCap': 'Verification-code emails are capped at 30 per address per day; if codes stop arriving, please do not keep requesting. Once signed in, set a password from the top-right avatar menu to log in without codes.',
  'login.hint.passwordWindow': 'A password works only in a browser that signed in with a login code within the last 7 days. If you changed your password recently, make sure the browser did not fill in the old one.',
  'login.hint.tz': 'Your display time zone will be set from your browser ({tz}); you can change it later in settings.',
  'login.error.emailRequired': 'Please enter your email address.',
  'login.error.emailInvalid': 'That email address looks invalid.',
  'login.error.codeRequired': 'Please enter the login code.',
  'login.error.passwordRequired': 'Please enter your password.',
  'login.error.invalidCode': 'The code is invalid or has expired.',
  'login.error.passwordRefused': 'Password sign-in is unavailable; please use a login code instead.',
  'login.error.network': 'Network error. Please try again.',
  'login.error.generic': 'Sign-in failed. Please try again.',
  // ── Batch 87: landing page for the one-time sign-in link in reminder mail ──
  'loginLink.pending': 'Signing you in…',
  // The backend answers all four failure causes identically; the UI keeps it that way.
  'loginLink.invalid': 'This sign-in link is no longer valid (it may have been used or expired). Please sign in with a login code instead.',
  'loginLink.error': 'Sign-in could not be completed right now. Please try again — the link may still be valid.',
  'loginLink.action.toLogin': 'Go to sign-in',

  // Placeholder pages (M2/M3 stubs) — retained for StubPage/fallback use.

  'common.retry': 'Retry',
  'common.cancel': 'Cancel',
  'common.close': 'Close',
  'common.save': 'Save',
  // ── C6 admin account management ──
  'admin.accounts.title': 'Account management',
  'admin.accounts.subtitle': 'Create, view, edit, and disable member accounts. Admin status is config-driven and not editable here (those rows are read-only).',
  'admin.git.title': 'Git access control',
  'admin.git.issue': 'Issue credential',
  'admin.git.username': 'Username',
  'admin.git.repo': 'Repository',
  'admin.git.canWrite': 'Write',
  'admin.git.label': 'Note',
  'admin.git.status': 'Status',
  'admin.git.active': 'Active',
  'admin.git.revoked': 'Revoked',
  'admin.git.revoke': 'Revoke',
  'admin.git.issued': 'Issued.',
  'admin.git.revokedOk': 'Revoked; effective immediately.',
  'admin.git.tokenOnce': 'The token is shown only this once (only its hash is stored) — copy and hand it over now:',
  'admin.git.conflict': 'This username already holds an active credential; revoke it first.',
  'admin.git.empty': 'No credentials yet.',
  'admin.git.error': 'The operation failed; please retry.',
  // ── Batch 135: issuance can ride a targeted secret delivery; wording re-aligned with
  // multi-repo issuance (the letter lists the REAL clone URLs of the selected repos —
  // after the two-table split it briefly carried only a placeholder). ──
  'admin.git.deliverInstead': 'Do not show it now — send it as a secret delivery to the owner account (the letter carries the real clone URLs of the selected repos and the usage)',
  'admin.git.deliverHelper': 'The system issues a named secret delivery (one pickup within 72 hours) whose body carries the token, each selected repo’s clone URL with its read/write posture, and both usages: the safe way (paste at the prompt, nothing written to disk) and the quick way (embedded in the command, stored in plain text). Grants can still change at any time afterwards — the token stays the same.',
  'admin.git.noGroup': 'That account is in no project group — the delivery has nowhere to land. Add them to a group first, or leave this unchecked and hand it over yourself.',
  'admin.git.delivered': 'Issued and handed over as secret delivery #{id} to {who}, valid until {t}.',
  'admin.git.deliveredHint': 'Tell them to pick it up under Secrets. It burns on reveal — one chance only. The clone URL and usage are inside the letter; nothing else to relay.',
  // ── git credential overhaul (inside/outside dual-track ruling): credential/grant two-level surface ──
  'admin.git.account': 'Owner account',
  'admin.git.accountNone': '(unbound)',
  'admin.git.boundTo': 'Owner: {who}',
  'admin.git.repoEmpty': 'The grantable-repo list is empty — register repos in the backend stage config (gitea section) first.',
  'admin.git.repoGrants': '{n} active grants',
  'admin.git.service': 'Service credential',
  'admin.git.usage': 'Used: {s}',
  'admin.git.usage.never': 'never',
  'admin.git.usage.count': '{n} times',
  'admin.git.readOnly': 'Read-only',
  'admin.git.grant.add': 'Add grant',
  'admin.git.grant.revoke': 'Revoke',
  'admin.git.grant.makeWrite': 'Make writable',
  'admin.git.grant.makeRead': 'Make read-only',
  'admin.git.grant.empty': 'No grants yet — a credential with no grants can reach no repository.',
  'admin.git.grant.allGranted': 'Every grantable repository is already granted.',
  'admin.git.grantConflict': 'The backend refused that grant change (most likely the repo already holds an active grant) — reload and check.',
  'admin.git.saved': 'Updated; effective immediately.',
  'admin.git.revokeCredential': 'Revoke credential',
  'admin.git.deliverNeedsAccount': 'Delivering needs the owner account selected — the letter is addressed by name.',
  // ── Batch 207 (SB-180 (e), real collision): multi-group recipients must pick the target group; nothing is guessed ──
  'admin.git.deliverGroup': 'Delivery group',
  'admin.git.deliverGroupHint': 'The delivery lands on the Secrets list of the selected group. This account belongs to several project groups — you pick the landing spot; the system never guesses.',
  'admin.git.deliverNeedsGroup': 'That account belongs to several project groups — pick the delivery group before issuing.',
  // ── Batch 175: multi-repo issuance + the usage-intro letter (a system template; no token plaintext) ──
  'admin.git.repos': 'Repositories (multi-select)',
  'admin.git.canWriteAll': 'Write on all selected repos',
  'admin.git.intro': 'Send usage intro',
  'admin.git.introSent': 'The intro letter is queued (a system template listing the current enabled grants and usage — no token plaintext).',
  'admin.git.introQueued': 'You already have a message to this person in flight — wait for it to send (or withdraw it), then send the intro.',
  'admin.git.introConflict': 'The backend refused this intro (the credential or its grants just changed) — refresh the page and look again.',
  'admin.git.intro.unbound': 'No owner account bound — there is no recipient to derive the letter’s address from. Use the Bind control below to add one.',
  // ── Batch 177: bind an owner account onto an existing credential (SB-180 (d)) ──
  'admin.git.bind.why': 'This credential has no owner account bound (a row carried over by the migration) — deliveries and intro letters both derive their recipient from the binding.',
  'admin.git.bind.btn': 'Bind',
  'admin.git.bind.ok': 'Bound. Intro letters and delivery derivation work immediately.',
  'admin.git.intro.noGrants': 'This credential holds no enabled grants — grant at least one repo first, or the letter would list nothing.',

  // ── Batch 55: project groups + the change-tracking switch ────────────────
  'admin.groups.title': 'Project groups',
  'admin.groups.subtitle': 'The only surface that operates document change tracking. Once enabled, the history seed shipped inside the image is imported at service start; history before the origin commit is never backfilled.',
  'admin.groups.empty': 'No project groups.',
  'admin.groups.slug': 'Slug',
  'admin.groups.tracking': 'Change tracking',
  'admin.groups.origin': 'Origin / enabled at',
  'admin.groups.on': 'Enabled',
  'admin.groups.off': 'Not enabled',
  'admin.groups.originUnknown': '(no origin commit — filtered by the enable time)',
  'admin.groups.irreversibleNote': 'Cannot be disabled',
  'admin.groups.enable': 'Enable tracking',
  'admin.groups.confirmTitle': 'Enable change tracking for "{slug}"?',
  'admin.groups.confirmIrreversible': 'This action cannot be undone: once enabled, it can never be switched off.',
  'admin.groups.confirmDesc': 'The origin is the commit of the currently published version; earlier changes are not backfilled. From then on every publish ships this group’s document-tree change records inside the image and imports them.',
  'admin.groups.confirm': 'Enable',
  'admin.groups.enabled': 'Enabled. History import starts after the next publish and restart.',
  'admin.groups.irreversible': 'Document change tracking cannot be switched off once enabled.',
  'admin.groups.notFound': 'No such project group.',
  'admin.groups.error': 'Failed to load project groups; please retry.',
  // ── batch 85: runtime project-group creation ─────────────────────────────
  'admin.groups.name': 'Name',
  'admin.groups.createTitle': 'New project group',
  'admin.groups.createHint': 'The slug becomes a segment of the published directory path and **cannot be changed** once created. Both names are required — the directory page renders one per language.',
  'admin.groups.slugLabel': 'Slug',
  'admin.groups.slugHelp': '2-40 characters: lowercase letters, digits and single hyphens; no leading or trailing hyphen.',
  'admin.groups.nameZh': 'Chinese name',
  'admin.groups.nameEn': 'English name',
  'admin.groups.create': 'Create',
  'admin.groups.created': 'Created "{slug}", together with its built-in friction item {friction}.',
  'admin.groups.slugTaken': 'That slug is already taken — pick another.',
  'admin.groups.err.slug.empty': 'Enter a slug.',
  'admin.groups.err.slug.length': 'The slug must be 2-40 characters.',
  'admin.groups.err.slug.uppercase': 'Slugs are lowercase only — on a case-insensitive filesystem two differently-cased slugs would point at one directory.',
  'admin.groups.err.slug.charset': 'A slug may only contain lowercase letters, digits and hyphens (no dots, slashes or spaces).',
  'admin.groups.err.slug.hyphenEdge': 'A slug cannot start or end with a hyphen.',
  'admin.groups.err.slug.hyphenDouble': 'A slug cannot contain two consecutive hyphens.',
  'admin.groups.err.name.empty': 'Enter a name.',
  'admin.groups.err.name.tooLong': 'Name too long (80 bytes max; a Chinese character counts as three).',
  // ── SB-202 S3 (batch 308, owner's instruction): project-level investor progress-report settings ──
  'admin.groups.report': 'Investor brief',
  'admin.groups.report.on': 'every {days} days',
  'admin.groups.report.off': 'Not enabled',
  'admin.groups.report.counts': '{recipients} recipients · {exclude} versions excluded · {gates} gates',
  'admin.groups.report.edit': 'Settings',
  'admin.groups.report.title': 'Investor progress report for "{slug}"',
  'admin.groups.report.hint': 'A daily sweep checks each group: a report is generated and sent only when enabled and at least the interval has passed since the last one. Before the first real send, use the command-line dry run to mail the same letter to yourself and check the format, then enable it here.',
  'admin.groups.report.enabled': 'Enable periodic sending',
  'admin.groups.report.everyDays': 'Interval (days)',
  'admin.groups.report.everyHelp': 'An integer from 1 to 60.',
  'admin.groups.report.recipients': 'Recipients (emails, one per line)',
  'admin.groups.report.recipientsHelp': 'Leave empty to send to every active investor account of this group.',
  'admin.groups.report.exclude': 'Versions excluded from the report',
  'admin.groups.report.excludeHelp': 'Comma- or newline-separated, e.g. v1.8, v1.9 — feature points and assets of these versions are left out of numerators and denominators.',
  'admin.groups.report.gates': 'Milestone gates (one per line: date | 中文 | English)',
  'admin.groups.report.gatesHelp': 'e.g. 2026-10-10 | 验收候选 tag | acceptance-candidate tag. The "N days to gate" lines in the report follow these.',
  'admin.groups.report.save': 'Save',
  'admin.groups.report.saved': 'Saved. The change is audited; the next due sweep uses the new settings.',
  'admin.groups.report.unchanged': 'Nothing changed.',
  'admin.groups.report.err.every': 'The interval must be an integer from 1 to 60.',
  'admin.groups.report.err.email': 'One of the recipients is not an email address.',
  'admin.groups.report.err.version': 'Version label too long (40 characters max).',
  'admin.groups.report.err.gate': 'Gates are one per line: YYYY-MM-DD | 中文 | English.',
  'admin.groups.report.err.rule': 'The server refused these settings (shape, email or date).',
  // batch 313: the same panel also sits at the top of the "Settings" page (where the owner looked for it)
  'admin.groups.report.panelTitle': 'Investor progress report · project-level settings',
  'admin.groups.report.panelIntro': 'One row per project group: whether to report, the interval, the recipients, excluded versions, milestone gates. Click "Settings" to change; the button of the same name in the project-group table on the "Accounts" page is the same one.',
  // ── batch 85: work-hours parameters on the admin surface ─────────────────
  'admin.workHours.title': 'Work-hours parameters',
  'admin.workHours.subtitle': 'The entry window and the work-day start hour. Neither lives in the deployment config — they have nothing to do with what code was deployed. Changes take effect at once and survive a restart.',
  'admin.workHours.windowDays': 'Entry window (days)',
  'admin.workHours.windowHelp': 'How many days are open for entry, centred on today. Must be a positive odd number (R-01). Shipped default {n}.',
  'admin.workHours.dayStartHour': 'Work-day start (hour)',
  'admin.workHours.dayStartHelp': '0-23 (R-32). Shipped default {n}. Changing it does not recompute existing hour packing.',
  'admin.workHours.save': 'Save',
  'admin.workHours.saved': 'Saved and in effect.',
  'admin.workHours.noChange': 'Nothing changed.',
  'admin.workHours.error': 'Could not load the work-hours parameters. Try again.',
  'admin.workHours.err.windowDays.empty': 'Enter an entry window.',
  'admin.workHours.err.windowDays.notInteger': 'The entry window must be a whole number of days.',
  'admin.workHours.err.windowDays.notPositive': 'The entry window must be positive.',
  'admin.workHours.err.windowDays.notOdd': 'The entry window must be odd — it is "N days centred on today", and an even number has no centre (R-01).',
  'admin.workHours.err.dayStartHour.empty': 'Enter a work-day start hour.',
  'admin.workHours.err.dayStartHour.notInteger': 'The work-day start must be a whole hour.',
  'admin.workHours.err.dayStartHour.outOfRange': 'The work-day start must be between 0 and 23 (R-32).',
  'admin.accounts.addTitle': 'Add a member',
  'admin.accounts.email': 'Email',
  'admin.accounts.headcount': 'Headcount',
  'admin.accounts.jobPost': 'Job post',
  'admin.accounts.displayName': 'Nickname',
  'shell.account.setPassword': 'Set a password',
  'shell.account.changePassword': 'Change password',
  'shell.pw.titleSet': 'Set a password',
  'shell.pw.titleChange': 'Change password',
  'shell.pw.explain': 'A password is a convenience channel: for 7 days after your last code login you can sign in with it directly instead of waiting for an email. Code login always works and is never affected by this.',
  'shell.pw.label': 'New password',
  'shell.pw.confirm': 'Repeat it',
  'shell.pw.helper': 'At least 8 characters.',
  'shell.pw.tooShort': 'A password needs at least 8 characters.',
  'shell.pw.mismatch': 'The two entries do not match.',
  'shell.pw.tooCommon': "That password is too common, or matches your email name. Please pick another.",
  'shell.pw.error': 'Could not set the password. Please try again.',
  'shell.pw.setNow': 'Set one now',
  'shell.pw.rotateNow': 'Change it now',
  'shell.pw.absentHint': 'You have not set a password yet. With one, you can sign in directly for 7 days after a code login instead of fetching an email every time.',
  'shell.pw.staleHint': 'Your password is more than 90 days old, so the password channel has been switched off — set a new one to restore it. Code login is unaffected and always available.',
  // ── SB-134（第一百一十四批）新版本提示 ──
  'shell.update.hint': '**This page is not running the current version.** The system was deployed after you opened it — new features do not exist for it, and changed interfaces are unknown to it. Reload when convenient; if this tab goes idle or into the background it will reload itself.',
  'shell.update.reload': 'Reload now',
  // ── SB-117（第一百一十三批）到期动作 ──
  'shell.nav.dueActions': 'Due',
  'shell.due.open': 'Go handle it',
  'shell.due.overdue': '**{n} due action(s) are overdue**, the oldest by {days} day(s): {title}. It will not go away on its own, and nothing else will bring it up.',
  'shell.due.today': '{n} due action(s) fall due today: {title}.',
  'shell.due.frame': '(due {dueOn}; today UTC {utc} / system timezone {local})',
  'due.title': 'Due actions',
  'due.subtitle': 'Things that must be done by hand on a given day. Past that day they do not disappear — they get louder.',
  'due.empty': 'Nothing pending.',
  'due.col.dueOn': 'Due on',
  'due.col.what': 'What to do',
  'due.col.owner': 'Who acts',
  'due.col.state': 'State',
  'due.overdueBy': '{days} day(s) late',
  'due.isToday': 'today',
  'due.done': 'Done',
  'due.abandon': 'Abandon',
  'due.settleNote': 'Leave a line (what you did / why you dropped it)',
  'due.showSettled': 'Include settled',
  'due.settledAt': 'settled',
  'due.settleFailed': 'Could not settle — try again.',
  'due.todays': 'Today: UTC {utc} / system timezone {local}. Rows whose date ends in Z are compared on the UTC day, the rest on the system-timezone day.',
  'due.frame.local': 'system-timezone day',
  'due.settledBy.person': 'settled by a person on this page',
  'due.settledBy.workspace': 'settled by the workspace',
  'due.settledBy.workspaceRef': 'settled by the workspace ({ref})',
  'due.settledBy.unknown': 'settler not recorded',
  'admin.accounts.clearQuota': "Clear today's code quota",
  'admin.accounts.quotaCleared': "Cleared this member's verification-code send quota for today.",
  'admin.accounts.slug': 'Member key',
  'admin.accounts.slug.helper': 'The stable handle documents use for this member (lowercase letters/digits/hyphens). Blank derives it from the email local-part.',
  'admin.accounts.slug.edit': 'The member key can be changed at any time: edit it in place, then press Enter or click away to save; clearing it returns the member to unset.',
  'admin.accounts.slugTaken': 'That member key is already taken — pick another (this is unrelated to the email address).',
  'admin.accounts.add': 'Add',
  'admin.accounts.created': 'Account created (it activates on first code login).',
  'admin.accounts.createIncomplete': 'Enter an email and choose a job post.',
  'admin.accounts.badEmail': 'Enter a valid email address (it must contain @).',
  'admin.accounts.emailExists': 'An account with this email already exists.',
  'admin.accounts.badRequest': 'Invalid request: check the email, job post, or status.',
  'admin.accounts.notFound': 'Account not found (it may have been removed).',
  'admin.accounts.conflictEdit': 'This account is config-managed and cannot be edited here.',
  'admin.accounts.updated': 'Updated.',
  'admin.accounts.passwordCleared': 'Password cleared (code login required next time).',
  'admin.accounts.status': 'Status',
  // Batch 107: last activity — NOT "last login" (one login can carry a month of
  // use). This column answers "is this account still being used at all", so
  // API-key traffic counts too.
  'admin.accounts.lastSeen': 'Last active',
  'admin.accounts.lastSeen.hint': 'When this account last sent a request with a valid credential (API-key traffic included). Recorded at a 5-minute granularity, so it can lag reality by a few minutes.',
  'admin.accounts.lastSeen.via.session': 'session',
  'admin.accounts.lastSeen.via.key': 'key',
  'time.since.justNow': 'just now',
  'time.since.minutes': '{n} min ago',
  'time.since.hours': '{n} h ago',
  'time.since.days': '{n} d ago',
  'admin.accounts.actions': 'Actions',
  'admin.accounts.status.active': 'Active',
  'admin.accounts.status.disabled': 'Disabled',
  'admin.accounts.disable': 'Disable',
  'admin.accounts.enable': 'Enable',
  'admin.accounts.resetPassword': 'Clear password',
  'admin.accounts.pending': 'Pending',
  'admin.accounts.configManaged': 'Config-managed',
  'admin.accounts.forbidden': 'Admin access required.',
  'admin.accounts.error': 'The operation failed; please retry.',
  'common.error.network': 'Network error. Please try again.',
  'common.error.session': 'Your session has expired. Please sign in again.',

  // ── Ticket type / status labels (shared by submit + my-tickets) ──────────
  'ticketType.bug': 'Bug',
  'ticketType.incident': 'Incident',
  'ticketType.maintenance': 'Maintenance',
  'ticketType.tech_debt': 'Tech debt',
  'ticketType.spec_change': 'Spec change',
  'ticketType.self_intro': 'Self-introduction',
  'ticketType.asset': 'Sample submission',
  'ticketType.assigned': 'Assigned',   // SB-190 (batch 245): ASK-, the response-clock carrier
  'ticketStatus.pending': 'Pending',
  'ticketStatus.processing': 'Processing',
  'ticketStatus.accepted': 'Accepted',
  'ticketStatus.rejected': 'Rejected',
  'ticketStatus.info_requested': 'Info requested',
  'ticketStatus.withdrawn': 'Withdrawn',
  'ticketStatus.reported': 'Reported',
  'ticketStatus.confirmed': 'Confirmed',
  'ticketStatus.handling': 'Handling',
  'ticketStatus.reviewed': 'Reviewed',
  'ticketStatus.published': 'Published',
  // SB-190 §3.1: the A machine's three states — "awaiting response" names the
  // clock on the responder, not the issuer
  'ticketStatus.assigned': 'Awaiting response',
  'ticketStatus.responded': 'Responded',
  'ticketStatus.closed': 'Closed',

  // ── M2 document browser ──────────────────────────────────────────────────
  'docs.title': 'Documents',
  'docs.tree.empty': 'No documents are visible to you.',
  'docs.tree.neverPublished': 'This project group has not published any documents yet - nothing is being withheld from you; the content has not landed here yet.',
  'docs.content.stalePending': 'What you are reading is NOT the peer\'s latest version: a content delivery newer than this page\'s publish time has not been merged yet.',
  'docs.content.behindBy': 'The published face is about {hours} hour(s) behind the peer\'s last delivery.',
  'docs.content.behindUnknown': 'How far behind CANNOT BE COMPUTED (one of the two timestamps is missing) - treat "possibly out of date" as the default; do not read it as "up to date".',
  'docs.tree.error': 'Failed to load the document tree.',
  'docs.tree.noGroup': 'This account is not in any project group yet - ask an admin to assign one on the admin page.',
  'docs.tree.expandAll': 'Expand all',
  'docs.tree.collapseAll': 'Collapse all',
  'docs.content.placeholder': 'Select a document from the tree on the left to read it.',
  'docs.content.error': 'Failed to load the document.',
  'docs.content.notFoundTitle': 'Document not found',
  'docs.content.notFoundDesc': 'This document does not exist, or is not visible to you.',
  'docs.content.forbiddenTitle': 'No access',
  'docs.content.forbiddenDesc': 'This document exists, but your job post cannot view its contents.',
  'docs.content.langUnavailableTitle': 'Not published in this language',
  'docs.content.langUnavailableDesc': 'This document is not yet published in the current language ({lang}).',
  'docs.content.availableLangs': 'Available languages: {langs}',
  // 2026-08-18 foreign single-language publishing (SOP-14 §7): a zh-only document is
  // shown in its original Chinese under the en UI, with this one honest sentence —
  // never a fabricated en page.
  'docs.content.zhOnlyNotice': 'This document is only available in its original Chinese.',
  'docs.content.proposeChange': 'Propose a change',
  'docs.content.switchTo': 'Switch to {lang}',
  'docs.link.unsupported': 'This link points to a folder; navigation is not supported yet.',
  'docs.link.broken': 'This link’s target document does not exist (recorded as a broken link at publish time).',
  'docs.content.back': 'Back',
  // Batch 103: audience exposure — who can actually see this document.
  'docs.audience.label': 'Visible to',
  'docs.audience.none': 'Admins only',

  // ── Batch 55: document change tracking ───────────────────────────────────
  'docs.content.updatedAt': 'Updated {time}',
  'docs.content.updatedTip': '{time} · commit {ref}',
  'docs.content.history': 'History',
  'docs.history.title': 'Change history',
  'docs.history.empty': 'No changes recorded for this document since tracking was enabled.',
  'docs.history.error': 'Failed to load the change history.',
  'docs.history.disabled': 'Change tracking is not enabled for this project group.',
  'docs.history.range': '{from}–{to} of {total}',
  'docs.history.newer': 'Newer',
  'docs.history.older': 'Older',
  'docs.history.committer': 'Workspace',
  'docs.history.event': 'Shipped with {no}',
  'docs.history.noEvent': 'Not linked to a release',
  'docs.history.diffEmpty': 'The diff body was not kept for this change (trimmed by the size budget).',
  'docs.history.diffError': 'Failed to load this change.',

  // ── M3 submit ticket ─────────────────────────────────────────────────────
  'submit.title': 'Submit ticket',
  'submit.subtitle': 'The submitter is your signed-in account; track status afterwards under "My tickets".',
  'submit.field.type': 'Type',
  'submit.field.title': 'Title',
  'submit.field.body': 'Description',
  'submit.field.submitLang': 'Submit language',
  'submit.field.projectGroup': 'Project group',
  'submit.field.targetDoc': 'Target document',
  'submit.field.targetDoc.helper': 'Brought in from the doc browser’s “Propose a change”. Click × to remove and enter a numeric id instead.',
  'submit.field.targetDocId': 'Target document id (advanced)',
  'submit.field.targetDocId.helper': 'Advanced fallback: type the target document’s numeric id. Normally, open the target in the doc browser and click “Propose a change” to bring in its docKey automatically.',
  'submit.hint.selfIntro': 'Submit a first draft of your self-introduction (capability inventory / energy allocation / self-declared ownership scope). An operator will then grill it layer by layer with AI assistance; once you confirm it, it becomes a basis for task assignment and progress estimation.',
  'submit.hint.asset': 'Sample submission: upload the sample files as attachments (the accepted types and caps are listed under the attachment field; state the source and selection rationale in the body; when collecting on assignment, fill in the related work-item number below).',
  'submit.field.relatedBacklog': 'Related work item (optional)',
  'submit.field.relatedBacklog.helper': 'When collecting samples on assignment, enter the BL- number so the workspace can group your submissions; it is written into the first line of the body.',
  // SB-190 §8 (batch 245): the assigned-ticket branch. The responder is fixed at issue
  // time and never changed ("the marker is never added later"), so the copy says
  // "cannot be changed" up front; "derived from" (P3) only points back — the origin
  // ticket is never touched.
  'submit.hint.assigned': 'Assigned ticket: issued by an approver or administrator and naming one responder. The responder is fixed the moment you issue it and cannot be changed afterwards; they are notified and see the ticket, with a respond box, under “My tickets”. Closing is yours or an approver’s to do — the responder can only respond.',
  'submit.field.assignee': 'Responder',
  'submit.field.assignee.helper': 'Pick from the list (type to filter). Cannot be swapped after issuing — asked the wrong person? Close this ticket and open another.',
  'submit.field.derivedFrom': 'Derived from (optional)',
  'submit.field.derivedFrom.helper': 'If this assigned ticket follows up on an existing ticket, enter its number (e.g. BUG-000012); the origin ticket is left untouched.',
  'submit.error.assigneeRequired': 'An assigned ticket needs a responder.',
  // SB-190 §3.1 P2 (batch 247): the 201 carries responseDeadline; when the rule is 1bd_defer
  // one more sentence - P2 is a deferred clock, not a refusal, so it hints and never blocks.
  // {n} = items already marked for that day before this one, {k} = the contract threshold
  // (SLA_SAME_DAY_THRESHOLD, same number as defaults.h); both come from code, never typed here.
  'submit.assigned.deferred': 'This member already has {n} items awaiting a response today; this one\'s clock starts at 00:00 of the next working day (contract: more than {k} on one working day defers).',
  // Assembled from the ATTACH_KINDS table in attachments.mjs (kind + extensions +
  // cap) — never hand-written as one sentence: the hand-written copy kept saying
  // "images / audio / video" long after the backend started accepting pdf/heic.
  'submit.attach.label': 'Attachments ({kinds})',
  'submit.attach.kind.image': 'images',
  'submit.attach.kind.doc': 'documents',
  'submit.attach.kind.audio': 'audio',
  'submit.attach.kind.video': 'video',
  'submit.attach.kind.package': 'packages',
  // Two kinds added by the 2026-09-17 ruling: animations (riv, the Rive runtime file)
  // and 3D models (glb/gltf, reserved for future 3D).
  'submit.attach.kind.animation': 'animations',
  'submit.attach.kind.model': '3D models',
  'submit.attach.kind.archive': 'archives',
  'submit.attach.kindSpec': '{kind} ≤{mb} MB ({exts})',
  'submit.attach.kindSep': ', ',
  'submit.attach.add': 'Choose files',
  'submit.attach.helper': 'Up to {n}; {groups}. Export slide decks as PDF (ppt/pptx are not accepted). Uploaded one by one after the ticket is submitted.',
  'submit.attach.uploaded': '{n} attachment(s) uploaded.',
  'submit.attach.failed': '{n} attachment(s) failed to upload. The failed files are still listed below — retry or remove them there. The ticket already exists; do not withdraw it and do not file a new one.',
  'submit.attach.retry': 'Retry {n} failed',
  'submit.attach.remove': 'Remove',
  'submit.attach.state.failed': 'Upload failed',
  'submit.attach.state.done': 'Uploaded',
  // Pick-time pre-validation (batch 58, C1). It must name the file, its actual size
  // and the limit: "file too large" cannot tell anyone WHICH of ten camera-roll
  // photos it was (IMG_4021.jpg all look alike by name) — and AST-000011 lost exactly
  // one photo, which shifted every row of a body table declared "in attachment order".
  'submit.attach.state.rejected': 'Not added',
  'submit.attach.reject.size': '{name} ({size}) is over the {mb} MB limit for {kind} and was not added. Compress it and pick it again, or use another accepted type.',
  'submit.attach.reject.type': '{name} ({ext}) is not an accepted file type and was not added. See the accepted types below.',
  'submit.attach.reject.empty': '{name} is empty (0 bytes) and was not added. Check that the file finished copying or downloading.',
  'submit.attach.rejectedNotice': '{n} file(s) did not pass the checks and will NOT be uploaded with this submission (each is marked in red below with the reason). If your body text lists the attachments in order, deal with these files first — otherwise the list will not match the attachments.',
  'submit.attach.order': 'Attachment #{n} (upload order)',
  'submit.attach.max': 'At most {n} attachments — {dropped} extra file(s) were not added.',
  // The detail panel's budget is "how many more THIS ticket can take", not "how many
  // you may pick" — separate wording, or a ticket with 7 files would read "at most 3
  // attachments" as if the rule had changed.
  'submit.attach.maxRemaining': 'This ticket can take {n} more attachment(s) (cap {total} per ticket) — {dropped} file(s) were not added.',
  'submit.attach.quotaLeft': 'This ticket can take {n} more attachment(s) (cap {total} per ticket).',
  'submit.attach.quotaFull': 'This ticket already has the maximum {total} attachments and can take no more. Describe any further material in a note, or contact the handler.',
  'submit.attach.blocked': 'Ticket {no} was created, but {n} attachment(s) did not upload. Retry them above or remove them — do not file another ticket.',
  // Retry re-sends only the failed files. Files picked AFTER the submit must not ride
  // along to the previous ticket — and the screen has to say so, or the user assumes
  // "retry" uploads everything in the list and their photo lands on someone else's ticket.
  'submit.attach.pendingNext': 'The other {n} file(s) were picked after the submit and will NOT go to {no} — retry re-sends only the failed ones; the new files stay here for your next submission.',
  // Per-file notes (batch 59, E1). AST-000011 hand-wrote a body table declared "in
  // attachment order"; one photo failed to upload and every row from #3 down then
  // labelled the wrong photo. So none of this copy may say "order": a note travels
  // WITH its file, and the generated manifest keys rows by filename + attachment id.
  'submit.attach.note.label': 'Note for this file (optional)',
  'submit.attach.note.placeholder': 'source; category; what it shows',
  // ── SB-067 phase 2 (batch 65): machine translation, shown late ────────────
  'locale.heading': 'Translation ({lang})',
  'locale.machine': 'machine translation · unverified',
  'locale.pending': 'A translation is being generated; refresh in a moment. The original is above and always takes precedence.',

  // ── SB-078 L2 (batch 66): the agent's pre-read ───────────────────────────
  // Every string says the same thing: **this is a draft; you are the one who rules**.
  // The accuracy of this agent's advice has not been measured even once, so nothing
  // here may read as though a decision has been made.
  'agentReview.title': 'AI pre-read',
  'agentReview.draftChip': 'draft · not a ruling',
  'agentReview.badge': '{n} question(s)',
  'agentReview.recommended': 'suggested',
  'agentReview.singleSelect': 'pick one',
  'agentReview.multiSelect': 'pick any',
  'agentReview.other': 'You can also pick none of these and write your own.',
  'agentReview.answerLater': 'This page shows the questions only for now; answering and the ruling ledger land shortly (rulings still travel the workspace).',
  'agentReview.askSubmitter': 'Facts to check with the submitter (not questions for you):',
  'agentReview.showRec': "Show the AI's suggested ruling and reasoning",
  'agentReview.hideRec': 'Hide the suggestion',
  'agentReview.rec.accept': 'Suggests: accept',
  'agentReview.rec.reject': 'Suggests: reject',
  'agentReview.rec.request_info': 'Suggests: ask the submitter for more',
  'agentReview.rec.need_ruling': 'Suggests: this one needs your ruling',

  // ── SB-076 phase 2 (batch 66, L3): answering ─────────────────────────────
  // **Answering transitions the ticket** (ruled by the owner this batch). The wording
  // must make clear that this click really moves the ticket — it is not a draft.
  'agentReview.otherPlaceholder': 'None of these — write your own (optional)',
  'agentReview.notePlaceholder': 'Note for the submitter (optional; lands in the ticket feedback)',
  'agentReview.action.accept': 'Accept',
  'agentReview.action.reject': 'Reject',
  'agentReview.action.request_info': 'Ask for more',
  'agentReview.submit': 'Record ruling and move the ticket',
  'agentReview.submitting': 'Submitting…',
  'agentReview.missing': '{n} question(s) still unanswered (if you cannot answer, write it under "none of these")',
  'agentReview.pickAction': 'Pick an action',
  'agentReview.ruledBy': 'ruled by {who}',
  'agentReview.round': 'round {n}',
  'agentReview.stale': 'What this ruling relied on has changed ({why}); a fresh pre-read has been queued',
  'agentReview.err.generic': 'Submission failed; the ticket is unchanged.',
  'agentReview.err.alreadyRuled': 'Someone ruled this question first — first answer wins. Reload to see it.',
  'agentReview.err.staleQuestion': 'The questions changed: the agent re-read this ticket after you opened the page. Reload and answer again.',
  'agentReview.err.staleDraft': 'The work-item draft changed: the agent re-read this ticket after you opened the page. Reload, read the new draft and decide again.',
  'agentReview.err.staleAsk': 'The agent re-reviewed this ticket after you loaded the page; its questions for the submitter are no longer the ones on your screen. Reload, read them, and decide again.',
  'agentReview.err.conflict': 'This ticket cannot be ruled right now (someone may be handling it, or it is already closed).',
  'agentReview.err.staleGround': 'What this pre-read stood on has changed, so the ruling was NOT executed (the ticket is unchanged). A fresh review has been queued — reload in a moment and answer again.',
  'agentReview.derived': 'Created work item {no}, linked to this ticket.',
  'notif.ruling_requested': 'Ticket {no} is waiting for your ruling',
  'notif.workspace_note': 'A message from the workspace',

  // ── SB-067 phase 1 (batch 64): AI polish ─────────────────────────────────
  'polish.button': 'AI polish',
  'polish.busy': 'Polishing…',
  'polish.revert': 'Restore what I wrote',
  'polish.remaining': '{n}/{limit} left today',
  'polish.done': 'Replaced with the polished draft. Not happy with it? Use "Restore what I wrote".',
  'polish.err.tooShort': 'Too short to polish — with this little text the model can only invent.',
  'polish.err.tooLong': 'This is longer than the limit for this field.',
  'polish.err.scene': 'Internal error: invalid polish scene.',
  'polish.err.exhausted': "You've used today's polish allowance. It resets tomorrow, in your timezone.",
  'polish.err.unavailable': 'The model service is unavailable right now. This did not count against your allowance, and your text is unchanged.',
  // This string is the one hard gate of the feature, as the user sees it.
  'polish.err.altered': 'The polished draft rewrote something that must not change (an identifier, path or link), so it was discarded. Your text is unchanged and this did not count against your allowance.',
  'polish.err.rejected': 'This content cannot be polished.',
  'polish.err.generic': 'Polishing did not succeed. Your text is unchanged.',
  'polish.altered.list': 'What it changed: {items}',

  // Batch 62 (SB-073): the note now travels WITH the file and lands on the attachment
  // row — no copy-paste step. The previous wording implied writing it was enough,
  // while in fact the text had nowhere to go: 67 attachments arrived, every note empty.
  'submit.attach.note.hint': 'What you write here is uploaded WITH the file and attached to it directly — no copying, and no shifted rows when a file fails to upload. One phrase is enough ("my cat", "my desk").',
  'submit.attach.notes.about': 'Generated by the page from the {n} attachment(s) that uploaded successfully. Each row is bound to its attachment id and stored filename — position carries no meaning. Do not edit by hand (change the file notes and regenerate instead).',
  'submit.attach.notes.title': 'Attachment notes manifest ({n} row(s))',
  'submit.attach.notes.copy': 'Copy manifest',
  'submit.attach.notes.copied': 'Manifest copied to the clipboard.',
  'submit.attach.notes.copyFailed': 'This browser refused clipboard access — select the text above and copy it manually.',
  // Honest copy: there is no "edit the body" endpoint (the me-family write routes are
  // create ticket / upload attachment / resubmit note / withdraw — nothing else), so a
  // submitted body is read-only. The manifest can only be computed AFTER the uploads
  // settle, by which time the body is already stored. So we do not pretend it was
  // appended — we hand it to the submitter.
  'submit.attach.notes.bodyLocked': 'Your notes have ALREADY been submitted with each file (they live on the attachment itself, so the handler sees them the moment they open the ticket). The manifest below is only for you to check against — nothing to copy, nowhere to paste it.',
  'submit.attach.notes.pendingLocked': 'This ticket’s body can no longer be edited. The manifest is generated below — copy and keep it; when the handler requests more information, paste it into the reply box (the page will also add it for you then).',
  // Batch 362: the issuer's upload box on an assigned ticket (ASK-). The line above is the
  // four-class wording — "the handler requests more information" and "the reply box" do not
  // exist on an assigned ticket. Three facts to state: the notes went up with the files; adding
  // files does not notify the assignee (a known behaviour, ticket-state-machine §8.4); the
  // window closes at the first response.
  'submit.attach.notes.askIssuer': 'Each note went up with its file (it lives on the attachment itself, so the assignee sees it on opening this assigned ticket); the manifest below is only for you to check against — nothing to copy and nowhere to paste it, since an assigned ticket has no reply box for the issuer. Adding attachments does not notify the assignee by itself; tell them separately if they need to look. Once the assignee first responds, attachments and notes can no longer be changed.',
  'submit.attach.notes.inReply': 'The attachment notes manifest was submitted with this reply ({n} row(s), keyed by filename and attachment id).',
  'submit.attach.notes.willRide': 'The manifest below rides along when you click “Resubmit” ({n} row(s), keyed by filename and attachment id) — no copying needed.',
  'submit.attach.notes.orphan': '{n} note(s) did not make it into the manifest — their files did not upload successfully. The manifest only ever lists attachments that really landed; that is the price of it never shifting. Upload those files and their notes will join the manifest automatically.',
  'attach.formulaRisk': 'This spreadsheet contains cells beginning with =, +, - or @, which may execute as formulas when opened in Excel or similar. Inspect it as plain text, or open it with formulas disabled.',
  // The detector is a best-effort escalation signal, not a gate — two characters get
  // past it — so every spreadsheet carries this caution and a detector hit merely
  // escalates the tone (the line above). The person at risk is the reviewer opening it.
  'attach.packageCaution': 'Package (apk): do not open or install it on a workstation. First check the sha256 below against the value the submitter declared separately, then install only on a test device (SOP-09 §4).',
  'attach.archiveCaution': 'Archive (zip): read the declaration in the ticket body first — which files it unpacks to and what each one is for — and only then unpack it, under temp/ rather than in place inside the repo. If the contents disagree with the declaration, ask for the manifest rather than inferring it (SOP-09 §5).',
  'attach.csvCaution': 'Spreadsheet file (csv): when opened in Excel or similar, cells beginning with =, +, - or @ may execute as formulas. Inspect it as plain text, or open it with formulas disabled.',
  'submit.hint.simpleTypes': 'Bug / Maintenance / Tech debt / Incident need no target document and submit directly.',
  'submit.action.submit': 'Submit',
  'submit.action.viewMine': 'View my tickets',
  'submit.success': 'Submitted — ticket {no}.',
  'submit.error.titleRequired': 'Please enter a title.',
  'submit.error.targetDocRequired': 'spec_change requires a target document (bring it in from the doc browser’s “Propose a change”).',
  'submit.error.forbidden': 'Your job post lacks the submit-ticket right.',
  'submit.error.groupsUnavailable': 'Could not load project groups; submission is unavailable. Please try again later.',
  'submit.error.generic': 'Submission failed. Please try again.',

  // ── M3 my tickets ────────────────────────────────────────────────────────
  'tickets.title': 'My tickets',
  'tickets.empty': 'You have not submitted any tickets yet.',
  'tickets.emptyFiltered': 'No tickets match the current filters.',
  'tickets.error': 'Failed to load your tickets.',
  'tickets.filter.status': 'Status',
  'tickets.filter.all': 'All',
  'tickets.filter.archived': 'Show archived',
  'tickets.col.no': 'No.',
  'tickets.col.type': 'Type',
  'tickets.col.title': 'Title',
  'tickets.col.updated': 'Updated',
  'tickets.archivedChip': 'Archived',
  // Batch 103: the group badge on all three ticket surfaces.
  'tickets.groupChip.tip': 'Project group',
  'tickets.action.submitNew': 'Submit a ticket',
  'tickets.count': '{n} item(s)',
  'tickets.detail.body': 'Body',
  'tickets.detail.feedback': 'Handling feedback',
  'tickets.detail.attachments': 'Attachments',
  'tickets.detail.timeline': 'Status timeline',
  'tickets.detail.author.me': 'Me',
  'tickets.detail.author.handler': 'Handler',
  'assetView.untitled': '(no caption)',
  'assetView.zoomIn': 'Zoom in',
  'assetView.zoomOut': 'Zoom out',
  'assetView.reset': 'Reset',
  'assetView.hintOn': 'Transparency hint: on',
  'assetView.hintOff': 'Transparency hint: off',
  'assetView.download': 'Download original',
  'assetView.help': 'Scroll or double-click to zoom around the cursor; drag to pan once zoomed. Reset returns to fit-to-view.',
  'assetView.helpTouch': 'Pinch with two fingers to zoom; once zoomed, drag with one finger to pan. Tap the empty area around the image, or Close, to exit.',
  'docs.tree.show': 'Show contents',
  'docs.tree.hide': 'Hide contents',
  // ── /admin/settings (SB-068/SB-077/SB-084, batch 68) ──────────────────────
  // ── Batch 80: per-account API keys (session-equivalent, admin-issued only) ─
  'admin.apiKeys.title': 'User API keys',
  'admin.apiKeys.scopeNote': 'A key is equivalent to that member’s signed-in session: it can do exactly '
    + 'what they can do on the pages, but it can NEVER reach the admin or approver pages '
    + '(do management work on the web page). A key is not a workspace token; the two are never interchangeable.',
  'admin.apiKeys.usageNote': 'Usage: send it as Authorization: Bearer <key>. '
    + 'A leaked key is the member’s account being impersonated — revoke and re-issue at once.',
  'admin.apiKeys.issue': 'Issue key',
  'admin.apiKeys.account': 'Account',
  'admin.apiKeys.pickAccount': 'Pick an account first.',
  'admin.apiKeys.label': 'Note',
  'admin.apiKeys.expiresInDays': 'Valid for (days)',
  'admin.apiKeys.expiresHint': 'Blank = never expires',
  'admin.apiKeys.status': 'Status',
  'admin.apiKeys.active': 'Active',
  'admin.apiKeys.expired': 'Expired',
  'admin.apiKeys.revoked': 'Revoked',
  'admin.apiKeys.revoke': 'Revoke',
  'admin.apiKeys.createdAt': 'Issued',
  'admin.apiKeys.expiresAt': 'Expires',
  'admin.apiKeys.lastUsed': 'Last used',
  'admin.apiKeys.never': 'Never',
  'admin.apiKeys.neverUsed': 'Never used',
  'admin.apiKeys.issued': 'Issued.',
  'admin.apiKeys.revokedOk': 'Revoked; the very next request fails.',
  'admin.apiKeys.keyOnce': 'The key is shown only this once — once you close this you cannot see it again '
    + '(only its hash is stored). Copy it and hand it over now; if it is lost, revoke and re-issue:',
  'admin.apiKeys.disabledAccount': 'This account is disabled; re-enable it before issuing a key.',
  'admin.apiKeys.empty': 'No keys for this account yet.',
  'admin.apiKeys.error': 'The operation failed; please retry.',
  // ── SB-148 C: onboarding quick-send (template message; body rendered server-side,
  // never containing key plaintext) ──
  'admin.apiKeys.onboarding.send': 'Send onboarding message',
  'admin.apiKeys.onboarding.sent': 'Sent',
  'admin.apiKeys.onboarding.sentOk': 'Onboarding message sent. Template messages do not queue; they will read it the next time they land on a page.',
  'admin.apiKeys.onboarding.error': 'Failed to send the onboarding message; please retry.',
  'admin.apiKeys.onboarding.rejected': 'The server rejected this onboarding message',
  // ── Batch 183: the client version behind each key (old clients get a soft reminder, never a refusal) ──
  'admin.apiKeys.client': 'Client',
  'admin.apiKeys.client.behind': 'Behind',
  'admin.apiKeys.client.upgrade': 'Upgrade needed',
  'admin.apiKeys.client.refs': 'Server current {cur}; minimum supported {min}. Old clients are not refused — ask the owner to selfupdate.',
  'admin.subnav.accounts': 'Accounts',
  'admin.subnav.git': 'Git access control',
  'admin.subnav.apiKeys': 'API keys',
  'admin.subnav.settings': 'Service settings',
  'admin.subnav.logs': 'Runtime logs',
  'admin.subnav.repos': 'Repositories',
  'admin.subnav.burn': 'Hours burn',
  'adminBurn.title': 'Work-hours burn reconciliation',
  'adminBurn.subtitle': 'Net work-hours per member per billing week (Mon–Sun), range {from} – {to} (last week + this week). Same semantics as the member work-hours page: net = logged − reversed, terminal rows excluded.',
  'adminBurn.member': 'Member',
  'adminBurn.thisWeek': 'This week (net)',
  'adminBurn.lastWeek': 'Last week (net)',
  'adminBurn.days': 'Daily spread',
  'adminBurn.empty': 'No work-hours entries in this range. Weekly totals appear here once members log hours.',
  'adminBurn.error': 'Failed to load burn data.',
  'adminBurn.capNote': 'Weekly cap lines follow the demo outsourcing contract (Amendment No. 1): 60h in the opening week, 40h from Aug 17; days at ≥9h are flagged in the warning colour. The cap lines expire with the demo.',
  'admin.repos.title': 'Repository browser',
  'admin.repos.subtitle': 'A rough look at what is in a repository. Text files are shown inline, binaries are download-only; branch granularity, no commit history.',
  'admin.repos.repo': 'Repository',
  'admin.repos.branch': 'Branch',
  'admin.repos.branchOnly': 'Branch granularity — this page carries no commit history',
  'admin.repos.root': '/',
  'admin.repos.name': 'Name',
  'admin.repos.size': 'Size',
  'admin.repos.emptyDir': 'This directory is empty.',
  'admin.repos.binary': 'Binary',
  'admin.repos.binaryHint': 'Binary files are not shown inline. Download it and open it with something that understands it.',
  'admin.repos.tooLarge': 'Text too large',
  'admin.repos.tooLargeHint': 'This is a text file, but at {size} it exceeds the {limit} inline limit. Truncated text looks complete, so only a download is offered.',
  'admin.repos.download': 'Download',
  'admin.repos.notFound': 'No such path on this branch.',
  'admin.repos.notProvisioned': 'The git bridge has no token, so no repository content can be read. This is not a permissions problem — configure the backend gitea token first.',
  'admin.repos.error': 'Could not read the repository. Try again.',
  // ── Batch 81: the runtime-log page ────────────────────────────────────────
  'admin.logs.title': 'Runtime logs',
  'admin.logs.intro': 'This page answers "what just happened". Entries are newest first, and restart markers are woven in at their place — the first question when reading a log is usually "did this error happen after the last restart?".',
  'admin.logs.filters.from': 'From',
  'admin.logs.filters.to': 'To',
  'admin.logs.filters.level': 'Level',
  'admin.logs.filters.levelAll': 'All levels',
  'admin.logs.filters.levelHint': 'The chosen level and everything above it (error is highest)',
  'admin.logs.filters.category': 'Category',
  'admin.logs.filters.categoryHint': 'Exact match, not a substring',
  'admin.logs.filters.regex': 'Regex (matches category, message and detail)',
  'admin.logs.filters.regexHint': 'ECMAScript regex; a malformed one is refused with a 400 rather than silently becoming "no results"',
  'admin.logs.filters.icase': 'Ignore case',
  'admin.logs.filters.pageSize': 'Per page',
  'admin.logs.apply': 'Search',
  'admin.logs.reset': 'Reset',
  'admin.logs.refresh': 'Refresh',
  'admin.logs.total': '{n} match(es)',
  'admin.logs.page': 'Page {page} of {pages}',
  'admin.logs.prev': 'Previous',
  'admin.logs.next': 'Next',
  'admin.logs.detail': 'Detail',
  'admin.logs.col.time': 'Time',
  'admin.logs.col.level': 'Level',
  'admin.logs.col.category': 'Category',
  'admin.logs.col.message': 'Message',
  'admin.logs.empty': 'No entries match in this window. Check two things before concluding anything: the write level may be keeping them out of the store, and an overflowing queue may have dropped rows — both look exactly like "a quiet day" on screen.',
  'admin.logs.writeLevel': 'Write level: {level}',
  'admin.logs.writeLevelHint': 'The write gate actually in effect. Anything below it never reaches the store — so "no debug entries" more likely means "never recorded" than "never happened".',
  'admin.logs.dropped': '{n} dropped',
  'admin.logs.droppedHint': 'Rows are dropped and counted when the write queue overflows. Dropping rows without saying so would present an incomplete record as a complete one.',
  'admin.logs.restartMarker': 'Service restart · {note}',
  'admin.logs.restartsUnavailable': 'Restart markers could not be fetched this time (the log itself is fine). Without them you cannot tell which run an error belongs to.',
  'admin.logs.err.range': 'The end time is earlier than the start time.',
  'admin.logs.err.regex': 'The regex is malformed and the server refused the query. Fix it and try again.',
  'admin.logs.err.absent': 'This node has no file-backed runtime log configured, so no rows exist to read (this is not "a quiet day").',
  'admin.logs.err.load': 'Could not read the logs. Please try again.',

  // Messages handed over by their recipients (batch 109 P1 (2), the narrow report channel).
  // The intro has to state the boundary: what you can read here is ONLY what a recipient
  // deliberately handed over. Without that sentence the next admin reads this panel as
  // "all in-app messages", which is exactly what this narrow channel is easiest to mistake.
  'admin.reported.title': 'Messages handed to the admins',
  'admin.reported.intro': 'Messages a recipient deliberately handed over, one message at a time. This is all you can read - every other in-app message is still invisible to you, including the rest of the exchange between these same two people. A handover cannot be undone, and the sender is not notified.',
  'admin.reported.empty': 'No one has handed over a message.',
  'admin.reported.err': 'Could not load the handed-over messages - this is not "nobody reported anything", it is this channel failing to fetch right now.',
  'admin.reported.who': '{from} wrote to {to}',
  'admin.reported.when': 'sent {sent} · read by the recipient {read} · handed over {reported}',
  'admin.reported.noBody': 'The text of this one did not come back (it is absent from the response). Do not read that as "the message was empty".',
  // ── Batch 81: the job queue (four counters that nothing rendered) ──────────
  'admin.settings.jobs.title': 'Job queue',
  'admin.settings.jobs.intro': "Background jobs such as translation and pre-read queue up here. Counters alone answer \"did anything fail\" but never \"why\" — so failed rows also carry the attempt count and the server's own last error.",
  'admin.settings.jobs.state.pending': 'Pending',
  'admin.settings.jobs.state.running': 'Running',
  'admin.settings.jobs.state.done': 'Done',
  'admin.settings.jobs.state.failed': 'Failed',
  'admin.settings.jobs.noFailures': 'No failed jobs.',
  'admin.settings.jobs.col.job': 'Job',
  'admin.settings.jobs.col.entity': 'Entity',
  'admin.settings.jobs.col.attempts': 'Attempts',
  'admin.settings.jobs.col.lastError': 'Last error (server verbatim)',
  'admin.settings.invalidModel': 'This model cannot be set right now',
  'agentReview.langNote': 'Questions are shown in the submission language ({lang})',
  'agentReview.toolTrace': 'The pre-read consulted {n} repository item(s):',
  'admin.settings.title': 'Service settings · the model each step uses',
  'admin.settings.intro': 'This is where you change **which model the system calls at each step**. Changes take effect immediately and **a redeployment does not clear them** (OQ-B28 phase two, per-key ruling: model selection is runtime-overridable). Each row shows three values — the deployed one, your override, and what is actually in effect — because they can disagree, and the moment they disagree is exactly the moment you need to see it.',
  'admin.settings.provider': 'Active provider',
  'admin.settings.col.op': 'Step',
  'admin.settings.col.configModel': 'Deployed',
  'admin.settings.col.override': 'Override with',
  'admin.settings.col.effective': 'In effect',
  'admin.settings.useDeploy': '(no override — use the deployed value)',
  'admin.settings.state.default': 'deployed value',
  'admin.settings.state.default.hint': 'No override set; follows the deployed configuration.',
  'admin.settings.state.override': 'override in effect',
  'admin.settings.state.override.hint': 'Your override is what is being used. A redeployment will not clear it.',
  'admin.settings.state.ignored': 'override ignored',
  'admin.settings.state.ignored.hint': 'The override is stored, but that model is no longer in this environment\'s routable set, so the system silently fell back to the deployed value. Pick a model that is currently available, or clear the override.',
  'admin.settings.src.discovered': 'discovered',
  'admin.settings.why.noVision': 'no vision',
  'admin.settings.why.unknown': 'capability unknown',
  'admin.settings.catalog.fresh': 'Model catalog: fresh',
  'admin.settings.catalog.stale': 'Model catalog: not refreshed for over a day',
  'admin.settings.catalog.never': 'Model catalog: never fetched (mock posture, or just deployed)',
  'admin.settings.catalog.count': '{n} selectable model(s)',
  'admin.settings.spend.title': 'LLM spend (last 30 days)',
  'admin.settings.spend.intro': 'Priced at read time from the input/output tokens each provider reported, at this deployment\'s per-1M rates. This is not an invoice — caching discounts, reasoning tokens and the like are not included; calls on unpriced models, or with no reported usage, are counted but not priced, and listed separately.',
  'admin.settings.spend.absent': 'This deployment has no database, so the spend ledger is not wired — no 0 is shown here, because "not wired" and "zero spend" are not the same thing.',
  'admin.settings.spend.pricedOf': 'priced · {n} call(s) in the period',
  'admin.settings.spend.incomplete': 'The figure above is incomplete:',
  'admin.settings.spend.caveat.unpriced': '{n} more call(s) used a model with no configured price — counted, not priced (usually a misspelt model name in the price table).',
  'admin.settings.spend.caveat.noUsage': '{n} more call(s) have no usage reading ({failed} of them failed — the provider may still have billed them) — counted, not priced.',
  'admin.settings.spend.col.model': 'Model',
  'admin.settings.spend.col.calls': 'Calls',
  'admin.settings.spend.col.priced': 'Priced',
  'admin.settings.spend.col.unpriced': 'Unpriced',
  'admin.settings.spend.col.noUsage': 'No usage',
  'admin.settings.saved': 'Saved; in effect now',
  'admin.settings.cleared': 'Override cleared; back to the deployed value',
  'admin.settings.error': 'Could not save. Please try again.',
  'admin.settings.authorityNote': 'Only **model selection** is editable here. The admin list, job-post rights and irreversible latches are authoritative in the deploy-time config; they cannot be changed here, and should not be (OQ-B28 phase two, per-key ruling).',
  'admin.settings.op.ticket_review': 'Ticket pre-read (the agent\'s grill)',
  'admin.settings.op.translate': 'Automatic ticket translation',
  'admin.settings.op.polish': 'AI polish',
  'admin.settings.op.asset_review': 'Asset vision review',
  'admin.settings.op.chat': 'Chat (smoke route)',
  'nav.adminSettings': 'Service settings',
  'approvals.title': 'Approvals',
  'approvals.readonlyNote': 'You can rule here: expand any ticket, answer the agent pre-read questions (if any), pick accept / reject / request more info and write a note — one submit does the pull, the transition and the ledger record together. The workspace channel still works, but it is no longer the only way in.',
  'approvals.error': 'Failed to load the approvals list',
  'approvals.empty': 'No tickets',
  'approvals.emptyFiltered': 'No tickets under the current filters',
  'approvals.filter.type': 'Type',
  'approvals.col.submitter': 'Submitter',
  'approvals.author.submitter': 'Submitter',
  'approvals.author.handler': 'Handler',
  'approvals.detail.submitter': 'Submitter',
  'approvals.detail.target': 'Target doc',
  'tickets.detail.resubmit.title': 'Add information and resubmit',
  'tickets.detail.resubmit.label': 'Supplementary note (optional)',
  'tickets.detail.resubmit.action': 'Resubmit',
  'tickets.detail.resubmit.done': 'Resubmitted — the ticket is back in the pending queue.',
  'tickets.detail.withdraw.action': 'Withdraw ticket',
  'tickets.detail.withdraw.title': 'Withdraw this ticket?',
  'tickets.detail.withdraw.desc': 'Withdrawing is terminal and cannot be undone: the ticket is closed for good, its number is spent, and the information-request thread and its attachments end with it. If you only need to add material, close this dialog, upload under "Add attachments" above and press Resubmit — there is no need to withdraw and re-file.',
  'tickets.detail.attach.title': 'Add attachments',
  // Batch 362: the assigned-ticket case (the third clause of attachment_window_open).
  'tickets.detail.attach.helper': 'You can add attachments while the ticket is pending or awaiting information — no need to withdraw and re-file. On an assigned ticket only the issuer can add them, and only until the assignee first responds.',
  'tickets.detail.attach.action': 'Upload attachments',
  // Shown on the collapsed row: picked-but-unsent files now live on the page and
  // survive collapsing — but the user must be able to SEE that they are still there.
  'tickets.detail.attach.pending': '{n} attachment(s) picked, not uploaded yet',
  'tickets.detail.attach.hold': 'Some attachments did not upload, so the resubmit was held. Retry or remove the failed files, then submit again.',
  'tickets.detail.withdraw.confirm': 'Withdraw',
  'tickets.detail.withdraw.done': 'Withdrawn.',
  // ── SB-190 §8 (batch 245): the assigned ticket's two actions and two labels ──
  // respond is the responder's only (repeatable; forms a feedback thread); close
  // belongs to the issuer / an approver / an admin — P1: the party being measured
  // never controls the ruler, so the responder's detail panel has no close button.
  'tickets.detail.author.assignee': 'Assignee',
  // What the responder sees on the issuer's feedback rows (the A2 closing note
  // included) — never "Me".
  'tickets.detail.author.issuer': 'Issuer',
  'tickets.roleResponder': 'Assigned to me',
  'tickets.detail.respond.title': 'Respond to this assigned ticket',
  'tickets.detail.respond.label': 'Your response',
  'tickets.detail.respond.action': 'Submit response',
  'tickets.detail.respond.done': 'Responded. You can add more — every response joins the thread.',
  'tickets.detail.close.title': 'Close this assigned ticket?',
  'tickets.detail.close.desc': 'Closing is the only exit for this kind of ticket and cannot be undone: the responder can no longer respond. To follow up, open a new assigned ticket and put this number under “Derived from”.',
  'tickets.detail.close.noteLabel': 'Closing note (optional)',
  'tickets.detail.close.action': 'Close assigned ticket',
  'tickets.detail.close.confirm': 'Close',
  'tickets.detail.close.done': 'Closed.',
  // SB-190 step 5: the "derived from" chip in the detail header - derivedFromNo has been on
  // the detail JSON since batch 245 and was rendered nowhere (P3: the origin ticket is never
  // touched; the chip only points back).
  'tickets.detail.derivedFrom': 'Derived from {no}',
  'app.langToggle.aria': 'Toggle language',
  'lang.zh': '中文',
  'lang.en': 'English',
  'ticketOp.archive': 'Archived',
  'ticketOp.unarchive': 'Unarchived',
  'ticketNote.auto': 'automatic',
  'ticketNote.timeoutRequeue': 'timeout requeue (§5.2)',
  'work.hoursValue': '{n}h',
  'workItems.untranslated': 'source {lang}',
  'rule.R-01': 'The selected day is outside the entry window (a few days around today).',
  'rule.R-04': 'That work item is in a terminal state (or was merged) — hours can no longer be logged.',
  'rule.R-05': 'The duration must be a positive multiple of 0.5 hours.',
  // Batch 84: the gateway gives each refusal its own error code (see workErrText
  // in WorkHoursPage); this catches an R-08 message thrown straight by the store.
  'rule.R-08': 'Planned hours can only be edited or deleted by their owner, and only before the day arrives.',
  'rule.R-11': 'The day’s total across all work items would exceed the 16-hour cap (planned included).',
  'rule.R-29': 'The friction built-in item does not accept direct hour entry.',
  'rule.R-36': 'The reversal is not allowed: only the owner may reverse an invested original row, and never beyond its amount.',
  'submit.field.relatedBacklog.groupMine': 'Related to me',
  'submit.field.relatedBacklog.groupOther': 'Other work items',
  'docs.stubBadge': 'To be written',
  'notif.aria': 'Notifications',
  'notif.aria.count': 'Notifications, {n} unread',
  'notif.label': 'Alerts',
  'notif.error': 'Failed to load notifications — try again shortly.',
  'notif.title': 'Notifications',
  'notif.readAll': 'Mark all read',
  'notif.empty': 'No notifications.',
  'notif.ticket_accepted': 'Your ticket {no} was accepted',
  'notif.ticket_rejected': 'Your ticket {no} was rejected',
  'notif.ticket_info_requested': 'Ticket {no} needs more information from you',
  'notif.ticket_auto_withdrawn': 'Ticket {no} was auto-withdrawn after the reply window lapsed',
  'notif.ticket_published': 'Your ticket {no} formally closed with a publication',
  'notif.incident_confirmed': 'The incident you reported, {no}, was confirmed',
  'notif.backlog_stakeholder_linked': 'You were made a stakeholder of work item {no}',
  'notif.backlog_stakeholder_unlinked': 'You were unlinked from work item {no}',
  'notif.backlog_requirements_changed': 'The requirements of work item {no} have changed',
  'notif.backlog_cancelled': 'Work item {no} was cascade-cancelled',
  // SB-052 (2026-08-17) the three ticket-side producers: T0 → approvers, T6 →
  // admins (the workspace-operator surrogate, trade-off in SB-052), I3 → submitter.
  'notif.ticket_submitted': 'New ticket {no} awaits processing',
  'notif.ticket_requeued': 'Ticket {no} timed out in processing and returned to the pending queue',
  // Batch 231: this one is not about a ticket, it is about the whole machine - once
  // the model service account refuses calls, every AI job after it fails. The wording
  // has to make the next action obvious.
  'notif.provider_blocked': 'The model service account is refusing calls (balance, quota or key) and AI jobs are all failing - requeue them from the jobs panel once the account is restored',
  'notif.incident_reviewed': 'The incident you reported, {no}, was reviewed and closed',
  // SB-190 §3.1 (batch 245): the A machine's three producers — A0 to the assignee,
  // A1 to the issuer, A2 to the assignee. The bell's default sends entityKind:'ticket'
  // to /my-tickets (notifTarget.mjs), so all three land on that page.
  'notif.ticket_assigned': 'Ticket {no} was assigned to you and awaits your response',
  'notif.ticket_responded': 'Assigned ticket {no} received a response',
  'notif.ticket_closed': 'Assigned ticket {no} was closed',
  'workItems.title': 'Work items',
  'workItems.subtitle':
    'Active work items (BL-) of the project group — pending or in progress. Expand an entry for its full description.',
  'workItems.onlyMine': 'Only mine',
  'workItems.mineChip': 'Assigned to me',
  'workItems.empty': 'No active work items right now.',
  'workItems.emptyFiltered': 'No work items are assigned to you.',
  'workItems.error': 'Failed to load work items.',
  'workItems.noGroup': 'This account has no available project group.',
  'workItems.status.pending': 'Pending',
  'workItems.status.in_progress': 'In progress',

  // ── Batch 102 (SB-106): project reports, read-only surface ──
  'reports.title': 'Project reports',
  'reports.subtitle':
    'Reports for the current project group. Written by the project side through the CLI and kept under revision; this page is read-only.',
  'reports.noGroup': 'This account has no available project group.',
  'reports.empty': 'This project group has no reports yet.',
  'reports.error': 'Failed to load the report list.',
  'reports.detailError': 'Failed to load this report.',
  'reports.gone': 'This report no longer exists (it may have just been renamed or removed).',
  'reports.selectHint': 'Pick a report on the left.',
  'reports.revision': 'Rev. {n}',
  'reports.updated': 'updated {time}',
  'reports.revisions': 'Recent revisions',
  'reports.revisionsEmpty': 'No revision history yet.',
  // batch 309 (SB-202 S3 remainder): tag chips by key prefix (the progress-report family newest first)
  'reports.tag.all': 'All',
  'reports.tag.other': 'Other',
  // Batch 104: the agent badge became a shared component (components/AgentChip.jsx),
  // so its keys left the reports namespace — group-thread messages show the same
  // badge with the same hint.
  'agent.badge': 'Agent',
  'agent.badgeHint': 'Written by an agent via an API key (the author is derived from the credential, never self-declared).',

  // ── Batch 102: account × project-group editing (admin surface) ──
  'admin.accounts.groups': 'Project groups',
  'admin.accounts.groups.none': 'No group',
  'admin.accounts.groups.edit': 'Edit',
  'admin.accounts.groups.title': 'Project groups for {email}',
  // Plain Typography, not MarkdownBody — no ** markers, they would print literally.
  'admin.accounts.groups.hint': 'The checked set becomes the account’s complete membership: saving replaces, so anything left unchecked is removed. Checking nothing is legal too — it means the account belongs to no project group.',
  'admin.accounts.groups.adminNote': 'Admins already see every project group; membership here does not change visibility, only which group the account belongs to.',
  'admin.accounts.groups.dropped': 'This account is still attached to archived or deleted project groups ({list}). Those can no longer be set, and this save removes them as well.',
  'admin.accounts.groups.empty': 'There are no project groups yet.',
  'admin.accounts.groups.saved': 'Project groups updated.',

  // ── Batch 104 B: inter-group threads ──
  'shell.nav.threads': 'Threads',
  'threads.title': 'Group threads',
  // Transparency posture (owner ruling): this page is NOT filtered by the current
  // group — everyone on the delivery team reads everything. This sentence is where
  // that ruling lands; without it, seeing other groups' threads reads like a leak.
  // Batch 108 C1 narrowed "every member" to "the delivery team": not copy polish —
  // whoever reads this line is deciding who will see what they are about to say,
  // and this batch changed that answer.
  'threads.subtitle': 'Communication threads between project groups — readable by everyone on the delivery team, not filtered by the current group. A thread may have several participating groups; only liaisons may start or reply, and messages speak for a group.',
  // What everyone else lands on (contract counterparties: outsourcing and external
  // consultants; owners: the investor side). It **states the reason**: a bare
  // "access denied" reads like a misconfiguration and gets filed as a ticket;
  // saying "this surface is not for you, and what you want lives over there" tells
  // the reader where to go next.
  //
  // ── Batch 108 R1 (B5): the third kind of reader ──
  // This line was written for those two audiences, but a THIRD one lands on it: an
  // internal engineer whose `job_post_key` has drifted from the config (a renamed
  // post, a stage image missing one, a typo'd key). The backend's `party_of` finds
  // no such post, returns an empty string, and he is not internal — so he reads
  // this same sentence, which then tells him he is an external partner or an owner.
  // That is a FALSE reason, and a false reason is worse than no reason: he will act
  // on it (file a contract-side ticket, or conclude he was demoted). Hence the way
  // out below — and it has to name the mechanism, or it is "contact an admin" with
  // extra words: a sentence that says neither why nor what to say.
  'threads.noAccess': 'Group threads are the delivery team\'s internal working surface, and this '
    + 'account is not part of it, so these threads are not shown. External partners: please use the '
    + 'ticket and contract channels. Owners: see project reports and approvals — those carry the '
    + 'settled conclusions. If you ARE on the delivery team, this is most likely not a ruling about '
    + 'you but a configuration drift: your job post does not declare that it belongs to the delivery '
    + 'team, or this environment\'s job-post table is missing it (a renamed post or a typo\'d key does '
    + 'exactly this). Tell us your email address and job post title — it is a one-line config fix, '
    + 'not a permission to re-apply for.',
  'threads.empty': 'No inter-group threads yet.',
  'threads.error': 'Failed to load the thread list.',
  'threads.detailError': 'Failed to load this thread.',
  'threads.gone': 'This thread no longer exists (it may have just been removed).',
  'threads.selectHint': 'Pick a thread on the left.',
  'threads.messages': '{n} messages',
  'threads.noMessages': 'This thread has no messages yet.',
  'threads.status.open': 'Open',
  'threads.status.closed': 'Closed',
  'threads.asGroupHint': 'This message speaks for that group.',
  'threads.partiesInferred': 'Participants pending',
  'threads.partiesInferredHint': 'The participating groups shown here were inferred from the two '
    + 'opening ends - the server returned no party set. If the server is already on the current '
    + 'version, this thread was most likely missed by the party backfill: report it to operations. '
    + 'Until it is fixed, a third group cannot speak for itself in this thread.',
  'threads.new': 'New thread',
  'threads.reply': 'Reply',
  'threads.replyAs': 'As group',
  'threads.notAParty': 'You belong to none of the groups participating in this thread, so you cannot speak in it (reading is unrestricted).',
  'threads.replyBody': 'Reply body',
  'threads.replied': 'Reply sent.',
  // Ruling 4: speaking in a thread with a pending archive proposal cancels it.
  // Unsaid, the user neither knows they withdrew someone else's proposal nor can
  // tell whether the chip that just vanished was a bug.
  'threads.repliedArchiveCancelled': 'Reply sent - and it also cancelled the archive proposal on this thread (speaking means the business is unfinished).',
  'threads.replyError': 'Failed to send the reply.',
  'threads.closedError': 'This thread is closed and takes no new messages.',
  'threads.forbidden': 'This account may not write inter-group threads (liaisons only).',
  'threads.form.subject': 'Subject',
  'threads.form.from': 'From group',
  'threads.form.to': 'To groups (pick one or more)',
  'threads.invite': 'Bring in',
  'threads.inviteLabel': 'Add a participating group',
  'threads.inviteHint': 'The added group may then speak in this thread; reading was open to everyone all along.',
  'threads.invited': 'That group has joined this thread.',
  'threads.inviteNoop': 'That group was already in this thread - nothing changed.',
  'threads.inviteError': 'Failed to add the group.',
  'threads.form.body': 'Body',
  'threads.form.create': 'Create',
  'threads.form.needSubject': 'Still missing: a subject.',
  'threads.form.needFrom': 'Still missing: the from group.',
  'threads.form.needTo': 'Still missing: at least one group to address.',
  'threads.form.sameGroup': 'The from group cannot also be listed as a target.',
  'threads.form.needBody': 'Still missing: a body.',
  'threads.created': 'Thread created.',
  'threads.createError': 'Failed to create the thread.',

  // ── Archiving with a three-day objection window (batch 125 C, owner ruling
  // of 2026-08-20) ──
  // The "pending" wording is load-bearing, not copy: whoever reads it is deciding
  // whether to speak up, and this is the one place in the system where saying
  // nothing counts as agreeing. Hence the chip carries the deadline, not just a state.
  'threads.archive.state.archive_pending': 'Archiving proposed',
  'threads.archive.state.archived': 'Archived',
  'threads.archive.dueAt': 'archives itself {at}',
  'threads.archive.dueNever': 'will not archive itself (the window is switched off)',
  'threads.archive.autoMark': 'archived automatically',
  'threads.archive.request': 'Propose archiving',
  'threads.archive.cancel': 'Cancel archiving',
  'threads.archive.reopen': 'Reopen',
  'threads.archive.showArchived': 'Show archived',
  'threads.archive.pendingHint': 'Any participating group may cancel this - and simply saying something in the thread cancels it too (unfinished business).',
  'threads.archive.archivedHint': 'Archived: read-only and hidden from the list by default. Reopen it to carry on.',
  // The window length is a SERVER SETTING (sweep.threadArchiveVetoDays): hard-typing
  // "three days" into copy makes that line a falsehood the day it is set to 7, with
  // nothing anywhere raising a word. So this family states the DEADLINE the server
  // computed (archiveDueAtMs) and never a number of days - dueAt already did this.
  // Criterion in pages/threads.test.mjs (no hand-typed digits anywhere in
  // threads.archive.* or notif.thread_archive_*).
  'threads.archive.requested': 'Archiving proposed: unless someone cancels, this thread archives itself on {at}.',
  // Window switched off (the backend sends archiveDueAtMs = null): it will NOT
  // complete on its own - that differs from the line above by one veto.
  'threads.archive.requestedNever': 'Archiving proposed. The automatic window is switched off, so it will not complete on its own.',
  // Confirmation body: nobody has pressed anything yet, so it may only speak in the
  // FUTURE tense (the line above is past tense - in a confirm box it says the deed
  // is done before the user acts). The one thing worth confirming is what SILENCE does.
  'threads.archive.confirmBody': 'This archives nothing right now: it opens an objection window. '
    + 'Any participating group may cancel inside it, and simply replying in the thread cancels it '
    + 'too (speaking means the business is unfinished). If nobody says anything before the '
    + 'deadline, the thread archives itself - silence counts as consent here, and every '
    + 'participating liaison gets a notification about it.',
  'threads.archive.cancelled': 'Archiving cancelled.',
  'threads.archive.reopened': 'This thread is open again.',
  'threads.archive.requestError': 'Failed to propose archiving.',
  'threads.archive.cancelError': 'Failed to cancel archiving.',
  'threads.archive.reopenError': 'Failed to reopen the thread.',
  // Four distinct 409s, four distinct next steps - the backend gives each its own
  // code, so the UI must not flatten them into one "try again".
  'threads.archive.vetoedError': 'An earlier proposal to archive this thread was cancelled, so '
    + 'silence no longer counts as consent here and it will not be archived again. Settle it in '
    + 'the thread; if the matter really is finished, open a fresh thread for what comes next.',
  'threads.archive.pendingError': 'Someone has already proposed archiving this thread: wait for the window to lapse, or cancel it.',
  'threads.archive.archivedError': 'This thread is already archived. Reopen it before speaking.',
  'threads.archive.nonePendingError': 'There is no archive proposal to cancel on this thread.',
  'threads.archive.notArchivedError': 'This thread is not archived, so there is nothing to reopen.',

  // ── Batch 109 D: in-app messages / secret pickup / CLI download ────────────
  'shell.nav.messages': 'Messages',
  'shell.nav.secrets': 'Secrets',

  // Messages - list surface
  'dm.title': 'Messages',
  'dm.subtitle': 'One-to-one notes. Every message must say what it is about; alerts can take up to a minute to appear.',
  'dm.tab.inbox': 'Inbox',
  'dm.tab.outbox': 'Outbox',
  'dm.empty.inbox': 'No messages received.',
  'dm.empty.outbox': 'No messages sent.',
  // batch-125: shown when "Awaiting a reply" filters the list down to nothing. Kept SEPARATE
  // from the two above: "No messages received" would read as if mail had gone missing,
  // when in fact every one of them has an answer - and the switch to prove it is right there.
  'dm.loadMore': 'Load more',
  'dm.loadMoreBusy': 'Fetching…',
  'dm.loadMoreError': 'That page did not come back — this is a failed fetch, not the end of the list. Try again.',
  'dm.empty.unreplied': 'Everything in this box has been answered.',
  // When the page came back full we dare NOT speak for the whole box
  // (unrepliedEmptyKey): this page holds only DM_PAGE_LIMIT rows, so the filter ran
  // over one page while the sentence above would claim the box - a flat falsehood
  // as soon as the inbox outgrows a page.
  'dm.empty.unrepliedPage': 'Everything on this page has been answered; the box holds more than this page, and the older ones are not shown.',
  'dm.error.list': 'Failed to load messages.',
  'dm.error.detail': 'Failed to load this message.',
  'dm.col.counterpart': 'Counterpart',
  'dm.col.anchor': 'About',
  'dm.col.state': 'Status',
  'dm.col.time': 'Time',
  'dm.dir.in': 'From {who}',
  'dm.dir.out': 'To {who}',
  'dm.state.queued': 'Queued',
  'dm.state.sent_unread': 'Sent · unread',
  'dm.state.read': 'Read',
  'dm.state.withdrawn': 'Withdrawn',
  'dm.state.failed': 'Not sent',
  'dm.anchor.same_group': 'Same group: {ref}',
  'dm.anchor.work_item': 'Work item {ref}',
  'dm.anchor.doc': 'Document {ref}',
  // Direction-neutral (SB-150 review): this line shows on outbox rows and on every level
  // of a quote chain, where authorship alternates - a "your message" would point at the
  // wrong person on alternating levels; the timestamp is enough to locate the letter.
  'dm.anchor.reply': 'In reply to the message sent {ref}',
  'dm.anchor.strong': 'You are a stakeholder of this',
  'dm.willSend.at': 'Goes out at {t}',
  'dm.willSend.blocked': 'Waits until they read your previous message',
  'dm.failReason.wait_expired': 'They did not read your previous message within three days, so this one never went out.',
  'dm.failReason.worker_gave_up': 'The system failed to send this after several attempts; please write it again.',
  'dm.exposed.in': 'This was written at {t} and waited here because you had not read the previous one.',
  'dm.exposed.out': 'This queued at {t} and only went out once they read your previous message - and they can see that.',
  'dm.unread.badge': '{n} unread',
  // SB-148 B: system messages (sent by an admin through a vetted template). The
  // recipient must be able to tell at a glance that no person hand-wrote this.
  'dm.system.chip': 'System message',
  // SB-190 §3.3 (batch 245): the "response required" badge. One badge on both sides and
  // on all three read faces (list / detail / forced-read gate) - the recipient must know
  // there is a clock on them, and the sender must know the recipient can see that.
  'dm.responseRequired.chip': 'Response required',
  // batch-125: "Replied" sits BESIDE the status chip rather than replacing it - the status is
  // still "Read", and "read but never answered" is exactly the cell this badge exists for.
  // One wording for both sides: on the inbox it means you answered, on the outbox they did.
  'dm.replied.chip': 'Replied',
  'dm.replied.at': 'Answered {t}',
  'dm.filter.unreplied': 'Awaiting a reply',

  // Messages - reading one
  'dm.read.open': 'Open',
  'dm.read.confirmTitle': 'Opening counts as read',
  'dm.read.confirmBody': 'The moment you open it, it counts as read: the sender is notified, and can no longer withdraw it.',
  'dm.read.confirmOk': 'Open',
  'dm.read.gone': 'The sender withdrew this before you opened it; the text is gone and the system kept no copy. If it mattered, ask them.',
  'dm.read.goneMine': 'You withdrew this message and the system cleared its text; a withdrawal that kept a copy would not be a withdrawal.',
  'dm.read.notFound': 'No such message.',
  'dm.read.readAt': 'They read this at {t}',

  // Messages - composing
  'dm.new.title': 'New message',
  'dm.new.to': 'To',
  'dm.new.toHelper': 'Pick someone from the list (type to filter); for anyone not listed, their email address works too.',
  'dm.new.toGroupSame': 'In my groups',
  'dm.new.toGroupHistory': 'Has written to me',
  'dm.new.anchor': 'What this is about',
  'dm.new.anchorHelper': 'The recipient needs to see why you can write to them: a shared group, a work item, a document, or their own message to you.',
  'dm.new.anchorLoading': 'Looking for what you both can see…',
  'dm.new.anchorEmpty': 'You have nothing in common that could anchor a message, so this one cannot be sent.',
  'dm.new.anchorTruncated': 'More candidates are not listed: narrow it down before picking.',
  'dm.new.anchorSearch': 'Pick a shared reference (type to filter)',
  'dm.new.body': 'Body',
  'dm.new.bodyFormat': 'Body format',
  'dm.new.schedule': 'Send later',
  'dm.new.scheduleHelper': 'Up to 72 hours out. Leave empty to send as soon as possible.',
  'dm.new.blocked': 'They have not read your previous message, so this one can only queue; it goes out by itself once they do.',
  'dm.new.blockedWindow': 'If they still have not read it within three days, this message will not be sent and you will be told.',
  'dm.new.pending': 'You already have a message queued to them (#{id}). One at a time: withdraw it, or wait for it to send.',
  'dm.new.send': 'Send',
  'dm.new.sent': 'Queued.',
  'dm.new.sentNow': 'Sent.',
  'dm.new.needTo': 'Still missing: the recipient.',
  'dm.new.needAnchor': 'Still missing: what this is about.',
  'dm.new.needBody': 'Still missing: the body.',
  'dm.new.tooLong': 'The body is {n} characters; the cap is 20000. Put the long form in a work item and anchor to it.',
  'dm.new.error': 'Failed to send.',
  'dm.new.recipientInactive': 'That account is disabled - a message to it would never be read. Pick someone else.',
  // SB-190 §3.3: the marker on the composer. Decided at send time and never added later -
  // this is where "the marker is never added afterwards" lands for the message channel,
  // so the copy says "cannot be added later" up front.
  'dm.new.responseRequired': 'Requires a response',
  'dm.new.responseRequiredHelper': 'Tick this if the message asks the recipient for an answer; they will see a "Response required" badge. Decided at send time - it cannot be added afterwards.',

  // Messages - withdrawal
  'dm.withdraw.action': 'Withdraw',
  'dm.withdraw.title': 'Withdraw this message',
  // Two sentences, branched by state (withdrawDescKey). One sentence for both
  // outcomes would promise a withdrawal the system cannot deliver: for a message
  // already in their inbox the ROW stays (withdrawal only clears the text).
  'dm.withdraw.descQueued': 'This one has not gone out yet, so withdrawing it leaves them nothing to see: the text is cleared and no copy is kept.',
  'dm.withdraw.descSent': 'This one is already in their inbox - they just have not opened it. Withdrawing clears the text and keeps no copy, but **they will still see a "withdrawn" row** (from whom, about what, when), and opening it tells them you took it back before they read it.',
  'dm.withdraw.ok': 'Withdrawn.',
  'dm.withdraw.tooLate': 'Too late: they opened it at {t}. Withdrawal only works before it is read.',
  'dm.withdraw.already': 'This was already withdrawn at {t}.',
  'dm.withdraw.failed': 'This never went out (it failed at {t}); there is nothing to withdraw.',
  'dm.withdraw.error': 'Failed to withdraw.',

  // In-app messages - the narrow report channel (batch 109 P1 (2), owner ruling).
  // The default still stands: admins cannot read other people's messages. This is the
  // one narrow slit, and only the recipient can open it. All three facts must be said
  // BEFORE the click (irreversible / this one message only / the sender is not told).
  'dm.report.action': 'Hand to admins',
  'dm.report.title': 'Hand this message to the admins',
  'dm.report.confirmBody': 'Admins will be able to read the text of **this one message**, and see who sent it to you and when. They cannot read anything else between the two of you - only this one goes over.',
  'dm.report.irreversible': 'This cannot be undone. There is no exception: a handover you can take back is just a switch you can probe with.',
  'dm.report.noNotice': 'The sender is not notified. This is not done behind their back - the point of reporting is to bring a third party in, and telling them first lets them react before anyone can.',
  'dm.report.confirmOk': 'Hand this one over',
  'dm.report.ok': 'Handed to the admins.',
  'dm.report.doneAt': 'You handed this message to the admins at {t} (it cannot be taken back).',
  'dm.report.error': 'Failed to hand it over.',

  // Messages - SB-150 quick reply & quoted original. The withdrawn/invisible lines
  // are honest terminal states (no retry): 410 = withdrawal physically cleared the
  // text, 404 = the concealment gate's own words - neither is a fault.
  'dm.reply.action': 'Reply',
  'dm.reply.lockedHelper': 'Replying to their message - the recipient and "about" are filled in and locked.',
  'dm.quote.expand': 'Show quoted message',
  'dm.quote.collapse': 'Hide',
  'dm.quote.withdrawn': 'The sender withdrew the original; its text no longer exists.',
  'dm.quote.notFound': 'The original is not visible to you.',
  'dm.quote.error': 'Failed to load the original.',

  // Messages - alerts (the bell polls once a minute; never promise "instant")
  'notif.dm_received': 'You have a new message',
  'notif.dm_read': 'Your message was read',
  'notif.dm_wait_expired': 'A queued message was not sent',

  // Inter-group thread archiving (batch 125 C). {no} is the thread id.
  // The first line has to spell out what SILENCE does: this is the one place in
  // the system where saying nothing counts as agreeing, and a notice that merely
  // announces the proposal reads as information rather than something to answer.
  // The deadline lives on the thread's own chip (a notification row carries only
  // kind/entityNo - there is no timestamp to interpolate here), so this line must
  // not hard-type a number of days: the window length is a server setting.
  'notif.thread_archive_requested': 'Archiving proposed for group thread #{no} - unless someone objects before the deadline it archives itself (the deadline is on the thread\'s "Archiving proposed" chip)',
  'notif.thread_archive_cancelled': 'The proposal to archive group thread #{no} was cancelled',
  'notif.thread_archived': 'Group thread #{no} was archived (it can be reopened at any time)',
  'notif.thread_reopened': 'Group thread #{no} was reopened',

  // Messages - forced-read gate (SB-146, batch 122; ruling of 2026-08-20 replaced
  // the automatic mark-as-read with a button the reader presses). The "why" line
  // must explain the interception: someone hitting a full-screen overlay for the
  // first time should not think the page is broken. The number of seconds is a
  // {s} placeholder filled from READ_COUNTDOWN_SECONDS — a hand-typed number goes
  // stale the day the constant moves (criterion in forcedReadQueue.test.mjs).
  'forcedRead.title': 'Unread messages to read first',
  'forcedRead.why': 'You have unread messages. To guarantee delivery, the system walks you through them before you continue browsing: scroll to the end of the text, wait out the {s}-second pause, then press “I have read this” to move on. Once all of them are read you are on your way.',
  'forcedRead.progress': 'Message {i} / {n} (oldest first)',
  'forcedRead.sentAt': 'Sent {t}',
  'forcedRead.scrollHint': 'Scroll to the end of the message to start the countdown.',
  'forcedRead.countdown': '{s}s to go…',
  'forcedRead.confirm': 'I have read this',
  'forcedRead.checking': 'Checking whether anything else is still unread…',
  'forcedRead.peekErr': 'Failed to load the message text — this one will not be skipped; please retry.',
  'forcedRead.readErr': 'Failed to mark it read — this one will not be skipped; please retry.',

  // Direct-login cleanup chain (SB-146 ruling 4). reason/why must explain WHY
  // the page navigates by itself.
  'cleanup.title': 'Clearing your unread notifications',
  'cleanup.reason': 'You signed in via an email link, so the system is walking you through your unread notifications one by one ({i}/{n}).',
  'cleanup.why': 'An email login link only shows you one page; if you leave after that, the rest of your notifications stay unread forever. So the system brings every unread notification in front of you: the page navigates by itself — this is not a bug. When you try to go elsewhere, it takes you to the next one first.',
  'cleanup.ok': 'Got it',
  'cleanup.markErr': 'Failed to mark this notification read — please retry, or the chain cannot continue.',
  'cleanup.deferNote': 'Marking has now failed several times in a row. You may defer this clearing round: the backlog stays on the server exactly as it is, and continues on your next direct login or refresh.',
  'cleanup.deferBtn': 'Defer clearing (backlog kept)',
  'cleanup.done.title': 'All caught up',
  'cleanup.done.body': 'Every unread notification has been shown and marked read. You are free to browse again.',

  // Error codes -> plain language (the errText byCode table)
  'dm.err.anchorRequired': 'A message must say what it is about.',
  'dm.err.anchorKind': 'Unknown anchor kind; pick one from the list.',
  'dm.err.anchorNotShared': 'They cannot see that anchor; pick something they can open.',
  'dm.err.alreadyQueued': 'You already have a message queued to them. One at a time.',
  'dm.err.alreadyRead': 'They have already read it; it cannot be withdrawn.',
  'dm.err.alreadyWithdrawn': 'This was already withdrawn.',
  'dm.err.alreadyFailed': 'This never went out; there is nothing to withdraw.',
  'dm.err.goneWithdrawn': 'This message was withdrawn; its text is gone.',
  'dm.err.recipientInactive': 'That account is disabled - a message to it would never be read.',
  'dm.err.subresourceBlocked': 'Use the button on the page for this one - it changes state (taking a secret burns it; opening a message marks it read), so the page is not allowed to trigger it by itself.',
  'dm.err.notRead': 'Open the message before handing it over - what you hand over is its text, and until you open it the sender can still withdraw it (which clears that text).',
  'dm.err.alreadyReported': 'You already handed this message to the admins, and a handover cannot be undone - there is nothing more to do here.',
  'secrets.err.goneTaken': 'This one-time secret has already been read and its text is gone for good. If that read was not yours, the credential has LEAKED: rotate it, do not ask for a resend.',
  'secrets.err.goneExpired': "This secret's window has closed; ask the issuer to send a new one.",
  'secrets.err.goneRevoked': 'This secret was revoked by its issuer or an admin; ask why before asking again.',
  'secrets.err.issuerCannotTake': "You issued this. Taking it is the recipient's action, and a one-time secret would burn here.",
  'secrets.err.alreadyRevoked': 'This delivery was already revoked.',
  'cli.err.distAbsent': 'This deployment carries no CLI bundle; that is a deployment-side gap, not your mistake.',

  // Secret pickup surface
  'secrets.title': 'Secrets',
  // 'Every one names its recipient' only holds for deliveries issued from batch 108
  // onward; legacy group-grain rows are fetchable by ANY member of the group, and
  // addressedToMe returns true for them. Do not let the copy claim otherwise (SB-122).
  'secrets.subtitle': 'Point-to-point credential handoffs. Newly issued ones name their recipient; a one-time secret burns when you take it. A few early deliveries were addressed to a whole group and any member can take them - check that one is meant for you before you do.',
  'secrets.empty': 'No secrets involve you.',
  'secrets.error': 'Failed to load secrets.',
  'secrets.col.label': 'Label',
  'secrets.col.from': 'From',
  'secrets.col.to': 'To',
  'secrets.col.mode': 'Kind',
  'secrets.col.state': 'Status',
  'secrets.col.created': 'Issued',
  'secrets.mode.once': 'One-time',
  'secrets.mode.ttl': 'Time-limited',
  'secrets.mode.onceTtl': 'One-time · valid until {t}',
  'secrets.state.available': 'Available',
  'secrets.state.taken': 'Taken',
  'secrets.state.expired': 'Expired',
  'secrets.state.revoked': 'Revoked',
  'secrets.take': 'Reveal',
  'secrets.take.confirmTitleOnce': 'Taking it burns it',
  // A ttl delivery does NOT burn (the store only clears the body when mode=='once').
  // Sharing the once title made the dialog contradict itself - and a warning that is
  // disproved on the spot trains people to ignore it on the run that matters.
  'secrets.take.confirmTitleTtl': 'Take this secret',
  'secrets.take.confirmBodyOnce': 'This is a one-time secret: once revealed it is gone for good, and closing this window loses it. Have somewhere to paste it first.',
  'secrets.take.confirmBodyTtl': 'You can reveal this again until {t}.',
  'secrets.take.confirmOk': 'Reveal',
  'secrets.body.label': 'Secret body',
  'secrets.body.copy': 'Copy',
  'secrets.body.copied': 'Copied.',
  'secrets.body.warning': 'This text exists only on this page; the system will not hand it to you again.',
  // SB-148 A: the second local exit. Each channel's leak surface must be named
  // BEFORE the choice; both stay available - the page does not choose for you.
  'secrets.download': 'Download as .txt',
  'secrets.download.note': 'Copying goes through the clipboard, downloading through the disk - two different leak surfaces: the clipboard keeps history and clipboard managers or cloud sync can carry it to other devices; a file stays on disk and can be indexed and backed up. Pick whichever fits your environment, and delete the file or clear the clipboard right after use.',
  'secrets.revoke': 'Revoke',
  'secrets.revoke.desc': 'Revoking clears the text as well. Only the issuer or an admin can do it.',
  // ── SB-159 (batch 178): load-more (same three lines as dm.* — separate keys so the two surfaces can diverge) ──
  'secrets.loadMore': 'Load more',
  'secrets.loadMoreBusy': 'Fetching…',
  'secrets.loadMoreError': 'That page did not come back — this is a failed fetch, not the end of the list. Try again.',
  'secrets.revoke.ok': 'Revoked.',
  'secrets.mine': 'Issued by me',

  // CLI download page (not in the nav; linked from /help)
  'cli.title': 'The dc-cli command-line tool',
  'cli.subtitle': 'Download the bundle, unpack it, and configure it once with your API key. Get the tool here first, then pick up your key under Secrets.',
  'cli.version': 'Version {v}',
  'cli.bundle.size': '{n} files, {kb} KB',
  'cli.bundle.sha': 'Bundle SHA-256: {sha}',
  'cli.bundle.shaHint': 'Check this against your download to confirm you got the whole thing.',
  'cli.download': 'Download zip',
  'cli.requirements': 'Requires Node.js 20 or newer.',
  'cli.steps.title': 'Three steps',
  'cli.steps.unpack': '1. Unpack anywhere (the archive already contains a dc-cli/ folder).',
  'cli.steps.key': '2. Pick up the API key an admin sent you, under Secrets.',
  // The bundle does NOT contain dc-cli.jsonc (it carries a plaintext key and is
  // excluded by DIST_DENY_BASENAMES) - only dc-cli.jsonc.example. Without `init`
  // the newcomer goes looking for a file that is not there and has to ask someone,
  // which is exactly what this page exists to prevent.
  'cli.steps.config': '3. In the unpacked folder run `node dc-cli.mjs init` to create dc-cli.jsonc, set apiKey to the key you just took and baseUrl to this site, then run `node dc-cli.mjs describe` to self-check.',
  // The bare `dc-cli` command only exists once you alias it yourself (no package.json
  // bin, no shim on PATH). Copying it verbatim yields command not found, and the
  // reader concludes the tool is broken when it is not.
  'cli.selfupdate': 'Once installed, `node dc-cli.mjs selfupdate` syncs against the server; you will not need to come back here. (Alias `node <path>/dc-cli.mjs` as `dc-cli` and the examples in the docs run verbatim.)',
  'cli.error': 'Failed to load the CLI distribution info.',

  // Admin - deferred API key pickup (ruling 1: reuse the secret delivery)
  'admin.apiKey.deliverInstead': 'Do not show it now - send it as a secret delivery',
  'admin.apiKey.deliverHelper': 'The system signs a one-time secret delivery addressed to that person, valid for 72 hours. You will not see the plaintext. If it expires unclaimed, just mint another one - re-minting takes seconds.',
  'admin.apiKey.delivered': 'Issued and handed over as secret delivery #{id} to {who}, valid until {t}.',
  'admin.apiKey.deliveredHint': 'Tell them to pick it up under Secrets. It burns on reveal: one chance only, so tell them to have somewhere to paste it.',
  'admin.apiKey.noGroup': 'That account is in no project group, so a delivery has nowhere to land. Add them to a group first, or leave this unchecked and hand the key over yourself.',
  // ── Batch 207 (SB-180 (e), real collision): multi-group recipients must pick the target group; nothing is guessed ──
  'admin.apiKey.deliverGroup': 'Delivery group',
  'admin.apiKey.deliverGroupHint': 'The delivery lands on the Secrets list of the selected group. This account belongs to several project groups — you pick the landing spot; the system never guesses.',
  'admin.apiKey.plaintextWarning': 'The plaintext appears exactly once; closing this loses it.',

  // == Batch 110 B: agent capability (three states / escape hatch / re-grill / draft) ==

  // The contract lists an agentReview.status.title; this implementation does NOT
  // use it: the status block renders inside the same Paper whose header already
  // reads agentReview.title ("AI pre-read"). A second synonymous heading in one
  // box is noise, and an unused key would sit in the dictionary forever
  // (keys.test.mjs structurally cannot see orphans).
  // A. Pre-read status. These three used to be pixel-identical on screen while the
  // next action for each is completely different.
  'agentReview.status.title': 'Pre-read status',
  'agentReview.status.not_applicable': 'This ticket type is not applicable for AI pre-read - nothing went wrong, and there is nothing to wait for.',
  'agentReview.status.never_queued': 'AI has never read this ticket.',
  'agentReview.status.queued': 'The AI pre-read is queued and has not started yet.',
  'agentReview.status.running': 'AI is reading this ticket right now.',
  'agentReview.status.failed.transient': 'The AI pre-read failed ({n} attempts): most likely a network or provider hiccup, so retrying is worth it.',
  'agentReview.status.failed.permanent': 'The AI pre-read failed: the request itself was rejected, and an identical retry will be rejected the same way - change the instructions and read another round.',
  // Same handling as the line above (neither retries automatically) but the opposite
  // instruction to the reader: that one says change the request, this one says do not.
  // Measured once in production: the screen answered "credit balance too low" with
  // "change the instructions and try again" - advice that could not have worked, and
  // it was the only signal anyone got.
  'agentReview.status.failed.account': 'The AI pre-read did not run: nothing is wrong with this ticket - the model service account is currently refusing calls (balance, quota or key). Do not change the instructions; requeue this job once the account is restored.',
  // This one cannot be folded into transient: an empty result_class on a legacy job
  // read as transient tells the reader "probably a network hiccup, try again" about
  // what was in fact a 400 - an invitation to three futile retries.
  'agentReview.status.failed.unknown': 'The AI pre-read failed for an unknown reason - this job predates failure classification.',
  'agentReview.status.skipped_quota': "Today's AI pre-read quota is used up, so this one was skipped - not a failure; it will be read as usual tomorrow.",
  'agentReview.status.escalated': 'AI says it cannot do this one. Its own reasoning is below.',
  'agentReview.status.lastAt': 'Last attempt: {when}',

  // B. The escape hatch on the approver surface: the agent's own words beat a blank.
  'agentReview.blocked.title': 'AI says it cannot do this',
  'agentReview.blocked.detail': 'In its own words:',
  'agentReview.blocked.wouldNeed': 'Give it these and it could:',
  'agentReview.blocked.reason.insufficient_context': 'not enough material',
  'agentReview.blocked.reason.out_of_scope': 'outside what it can judge',
  'agentReview.blocked.reason.contradictory_instructions': 'the instructions contradict each other',
  'agentReview.blocked.reason.tooling_blocked': 'it could not reach what it needed to read',
  'agentReview.blocked.reason.unsafe_request': 'it should not do this',

  // C. Manual re-grill. Directives are presets (system turn); the free note is
  // material, not instructions (user turn).
  'agentReview.rerun.open': 'Have AI read it again',
  'agentReview.rerun.title': 'Have AI read it again',
  'agentReview.rerun.desc': 'Run the pre-read again. You may add a few directives, and you may supply a fact it was missing.',
  'agentReview.rerun.warnStale': 'A re-run replaces the current set of questions: any answers you or another approver have not submitted yet are superseded and become void (they will be rejected on submit). Rulings already recorded are untouched - rulings are never overwritten.',
  'agentReview.rerun.directives': 'Add a few directives (optional)',
  'agentReview.rerun.directive.draft_work_item': 'Draft a work item',
  'agentReview.rerun.directive.focus_scope': 'Focus on scope boundaries',
  'agentReview.rerun.directive.focus_cost': 'Focus on cost and schedule',
  'agentReview.rerun.directive.focus_risk': 'Focus on risk',
  'agentReview.rerun.directive.check_duplicate': 'Check whether this is a duplicate',
  'agentReview.rerun.directive.ask_submitter': 'List the facts to verify with the submitter',
  'agentReview.rerun.notePlaceholder': 'Supply a fact it was missing (optional). For example: "that machine" means the dev instance, not production.',
  // First line of defence on the product side: an approver who believes he is giving
  // orders will read the result through a sentence that was never executed.
  'agentReview.rerun.noteCaution': 'What you write here is MATERIAL, not an instruction: the agent will not carry out requests inside it.',
  'agentReview.rerun.noteCount': '{n} / {max} characters',
  'agentReview.rerun.submit': 'Queue a re-read',
  'agentReview.rerun.submitting': 'Queueing...',
  'agentReview.rerun.queued': 'Queued: round {round}. Until it finishes this page still shows the previous round - refresh in a moment.',
  'agentReview.rerun.err.inFlight': 'A round is already running; wait for it to finish.',
  'agentReview.rerun.err.notReviewable': 'This ticket cannot be pre-read right now: either this type is not pre-read, or the ticket is closed.',
  'agentReview.rerun.err.tooMany': 'This ticket has already been re-run manually {n} times today - that is the cap. Try tomorrow.',
  'agentReview.rerun.err.budgetReserved': "Today's remaining AI allowance is reserved for the automatic pre-read of newly submitted tickets. A manual re-run has to wait until tomorrow - you did nothing wrong.",

  // D. The previous round. Collapsed by default, and read-only (history questions
  // carry no key at all).
  'agentReview.history.show': 'Show the previous {n} round(s)',
  'agentReview.history.hide': 'Hide history',
  'agentReview.history.round': 'Round {n}',
  'agentReview.history.supersededAt': 'superseded {when}',
  'agentReview.history.readOnly': 'Superseded: readable, not answerable',
  'agentReview.history.directives': 'Directives that round carried: {list}',
  'agentReview.history.noDraft': 'That round proposed no work-item draft.',

  // E. Work-item draft: the agent proposes, a human presses the button.
  'agentReview.draft.title': 'AI suggests opening a work item',
  'agentReview.draft.kind': 'Kind: {kind}',
  'agentReview.draft.kind.bug': 'Bug',
  'agentReview.draft.kind.maintenance': 'Maintenance',
  'agentReview.draft.kind.tech_debt': 'Tech debt',
  'agentReview.draft.scope': 'Scope:',
  'agentReview.draft.stakeholders': 'Stakeholders:',
  'agentReview.draft.why': 'Why it deserves its own item:',
  'agentReview.draft.adopt': 'Create the work item from this draft on accept',
  // "Say what will happen before adopting" lands here: what gets created, what it is
  // linked to, and who is recorded as its owner.
  'agentReview.draft.adoptHint': 'With this ticked, submitting the ruling creates one work item: title and scope taken from the draft above, linked to this ticket, and owned by YOU - not by the AI. Left unticked, it is created the old way: the ticket title plus your answers, copied verbatim.',
  'agentReview.draft.blockedByExisting': 'This ticket is already linked to work item {no}, so no second one was created and the draft was not adopted.',
  'agentReview.draft.adopted': 'Created work item {no} from the draft and linked it to this ticket.',
  'agentReview.err.noDraft': 'This pre-read carries no adoptable work-item draft (a new round may have just replaced it). Refresh and look again.',
  'agentReview.err.draftNeedsAccept': 'A work item is only created on accept. To adopt this draft, set the action to accept first.',

  // ── Batch 111 D (OQ-C50): send the agent's questions as a request for info ──
  // The line the design doc claimed for two batches while nothing implemented it:
  // approvers were retyping, by hand, questions the agent had already written.
  // The draft is editable before it goes out — what goes out is THEIR wording.
  'agentReview.ask.useDraft': 'Ask the submitter these',
  'agentReview.ask.hint': 'Fills the note with these questions and sends them to the submitter as a request for more information. Edit it first if you like — what goes out is **your** wording.',
  'agentReview.ask.header': 'Please supply the following facts:',
  'agentReview.ask.footer': 'Reply on this ticket once you have them.',
  'agentReview.ask.filled': "The note now carries the agent's {n} question(s). Edit, then send.",
  'agentReview.ask.overwriteTitle': 'The note is not empty',
  'agentReview.ask.overwriteBody': 'Filling in the draft replaces the {n} character(s) you already wrote. This does not merge the two: a merged paragraph has no author.',
  'agentReview.ask.overwriteOk': 'Replace',
  'agentReview.ask.cancel': 'Cancel',
  'agentReview.ask.needsRequestInfo': 'These are for the **submitter**, so they only go out as a request for more information — this button switches the action for you.',
  // Say, before sending, where the ticket lands and what the submitter receives.
  'agentReview.ask.willHappen': 'On submit: this ticket moves to "info requested", your text becomes a ticket feedback entry, and a notification appears in the submitter\'s bell (plus a reminder email if they have not signed in for a day). When they reply on this ticket it returns to "pending".',
  'agentReview.ask.sent': "Sent the agent's {n} question(s) to the submitter as a request for more information.",

  // F. Per-row pre-read badges in the approval queue. "All fine" costs no pixels,
  // so only these three exist.
  'approvals.reviewState.failed': 'pre-read failed',
  'approvals.reviewState.escalated': 'AI says it cannot',
  'approvals.reviewState.queued': 'AI is reading',

  // G. Admin: the agent's escape-hatch reports.
  'admin.subnav.escalations': 'AI feedback',
  'admin.escalations.title': 'Things the AI says it cannot do',
  'admin.escalations.desc': 'Reports the agent leaves when it gives up mid-task: what it could not do, why, and what would have let it. This page does not ask "what about this ticket" (that is the approvals page) but "what is systematically wrong with how this system hands out work". If "not enough context" dominates over time, the problem is the material we feed it, not the agent.',
  'admin.escalations.empty': 'No reports awaiting action.',
  'admin.escalations.filter.unacked': 'Open',
  'admin.escalations.filter.acked': 'Handled',
  'admin.escalations.filter.all': 'All',
  'admin.escalations.col.at': 'Time',
  'admin.escalations.col.op': 'Step',
  'admin.escalations.col.entity': 'Subject',
  'admin.escalations.col.reason': 'Reason',
  'admin.escalations.col.detail': 'What it said',
  'admin.escalations.col.state': 'Handling',
  // Deliberately NOT shared with agentReview.blocked.reason.*: different audience,
  // different wording. The approver hears "it could not keep reading because X is
  // missing from the material"; the admin hears "the assembler is short on input".
  'admin.escalations.reason.insufficient_context': 'Insufficient context (assembler short on input)',
  'admin.escalations.reason.out_of_scope': 'Out of judgeable scope (task definition)',
  'admin.escalations.reason.contradictory_instructions': 'Contradictory instructions (prompt or ticket at odds)',
  'admin.escalations.reason.tooling_blocked': 'Tooling blocked (could not reach the material)',
  'admin.escalations.reason.unsafe_request': 'Refused (judged it should not)',
  'admin.escalations.wouldNeed': 'It says these would have been enough:',
  'admin.escalations.directives': 'Directives that round carried:',
  'admin.escalations.toolTrace': 'It looked at {n} place(s) before giving up:',
  'admin.escalations.byReason': 'All reports by reason: {list}',
  'admin.escalations.ack': 'Acknowledge',
  'admin.escalations.ackNotePlaceholder': 'Handling note (required): how you intend to handle this. For example: opened SB-126 to close the gap in the assembler.',
  'admin.escalations.acked': 'Handled by {who} at {when}',
  'admin.escalations.err.alreadyAcked': 'Someone already handled this one. Refresh to read what they wrote.',
  'admin.escalations.err.emptyNote': 'Handling needs a sentence: an unexplained "handled" is indistinguishable from "nobody looked".',

  // G2. Admin: subject audit of the sensitive read surfaces (SB-116, batch 121).
  'admin.subnav.readAudit': 'Read records',
  'admin.readAudit.title': 'Who read this resource',
  'admin.readAudit.desc': 'Subject audit of the sensitive read surfaces (cross-group threads, secret deliveries, the account roster, hidden documents): one row per read-gate verdict — allowed and denied alike (a denied attempt is intelligence too: who was probing). Query by resource id, optionally within a time window. Records are kept 180 days; older rows are purged automatically.',
  'admin.readAudit.resource': 'Resource id',
  'admin.readAudit.resourceHint': 'e.g. group-thread:7, group-threads, secret-delivery:3, admin:accounts, doc:MirrorMii/documents/contracts/x',
  'admin.readAudit.from': 'From',
  'admin.readAudit.to': 'To',
  'admin.readAudit.query': 'Query',
  'admin.readAudit.prompt': 'Enter a resource id first — this page has no "browse everything": the audit is queried on demand, not browsed.',
  'admin.readAudit.empty': 'No records in this window. Note this does not mean "nobody read it" — the window may be off, and rows beyond the 180-day retention have been purged.',
  // Gate verdicts, not content delivery: an allowed row can still end in 410 (burned)
  // or 404 (gone) with no bytes served. Copy that crosses that line makes the ledger
  // lie exactly when a leak investigation needs it (batch-121 adversarial review).
  'admin.readAudit.readers': 'Allowed through the gate: {list} (allowed does not imply content was served - burned/removed resources can still end in 410/404).',
  'admin.readAudit.probers': 'Denied but tried: {list}.',
  'admin.readAudit.col.at': 'Time',
  'admin.readAudit.col.who': 'Who',
  'admin.readAudit.col.verdict': 'Verdict',
  'admin.readAudit.col.credential': 'Credential',
  'admin.readAudit.col.surface': 'Surface',
  'admin.readAudit.verdict.allowed': 'allowed',
  'admin.readAudit.verdict.denied': 'denied',
  'admin.readAudit.cred.session': 'web session',
  'admin.readAudit.cred.key': 'API key',
  'admin.readAudit.err.resource': 'Enter a resource id first.',
  'admin.readAudit.err.range': 'The from/to times are inverted.',

  // G3. Admin: the response-SLA read face and ruling desk (SB-190 §7.3, batch 246; 03-scoring D4 ①).
  // Keys live under admin.responseSla.*: the design's sla.* family is reserved for the step-5 member face.
  'admin.subnav.responseSla': 'Response SLA',
  'admin.responseSla.title': 'Response SLA: who answered within one working day',
  'admin.responseSla.desc': 'The read face of 03-scoring D4 ① (10 points): every item in the window that asked a named party for a response (assigned tickets, information requests, messages marked "response required"). The clock is computed on America/Vancouver working days, the machine lists candidates, and WHICH ONE counts as the first substantive response is a person\'s ruling - a ruling is a new row in an append-only ledger; rule again to correct one. The rows the contractor sees in `sla mine` are literally these.',
  'admin.responseSla.responders': 'Responder account ids',
  'admin.responseSla.responders.helper': 'comma-separated, e.g. 9,12; empty = every responder (internal members included in the denominator)',
  'admin.responseSla.responders.all': 'all',
  'admin.responseSla.from': 'From',
  'admin.responseSla.to': 'To',
  'admin.responseSla.query': 'Query',
  'admin.responseSla.prompt': 'Pick the responders and the window, then query - the default window is the last 30 days.',
  'admin.responseSla.empty': 'No item in this window asked for a response.',
  'admin.responseSla.err.range': 'The from/to times are inverted.',
  'admin.responseSla.err.responders': 'Responders must be account ids (positive integers), comma-separated.',
  'admin.responseSla.calendar': 'Calendar {tz} · holidays {holidays} · same-day threshold {threshold} · window [{from}, {to}) · responders {responders}',
  'admin.responseSla.summary.denominator': 'Denominator',
  'admin.responseSla.summary.numerator': 'Numerator',
  'admin.responseSla.summary.score': 'Score (out of 10)',
  'admin.responseSla.summary.scoreRange': 'Range (rulings pending)',
  'admin.responseSla.summary.needsRuling': 'Needs ruling',
  'admin.responseSla.summary.pending': 'Within deadline',
  'admin.responseSla.summary.excluded': 'Excluded',
  'admin.responseSla.summary.integrity': 'Witness mismatches',
  'admin.responseSla.col.channel': 'Channel',
  'admin.responseSla.col.ref': 'Item',
  'admin.responseSla.col.responder': 'Responder',
  'admin.responseSla.col.issuer': 'Issuer',
  'admin.responseSla.col.markedAt': 'Marked at',
  'admin.responseSla.col.deadline': 'Deadline',
  'admin.responseSla.col.rule': 'Rule',
  'admin.responseSla.col.rank': 'Rank that day',
  'admin.responseSla.col.state': 'State',
  'admin.responseSla.col.candidates': 'Candidates',
  'admin.responseSla.col.rulings': 'Rulings',
  'admin.responseSla.col.action': 'Action',
  'admin.responseSla.frozen': 'frozen',
  'admin.responseSla.witnessMismatch': 'Mark and witness disagree - check the database before reading the score',
  'admin.responseSla.kind.substantive': 'substantive (a conclusion or data)',
  'admin.responseSla.kind.not_substantive': 'not substantive (acknowledgement only, does not count)',
  'admin.responseSla.kind.provisional': 'provisional (a clear next step, to be honoured by the promised day)',
  'admin.responseSla.kind.honoured': 'honoured (points at that provisional candidate)',
  'admin.responseSla.kind.not_honoured': 'not honoured (counted late retroactively)',
  'admin.responseSla.kind.extend': 'extend (while a blocker lasts, in working days)',
  'admin.responseSla.kind.exclude': 'exclude from the denominator (wrong addressee, duplicate, withdrawn question)',
  'admin.responseSla.ruling.title': 'Rule',
  'admin.responseSla.ruling.kind': 'Ruling kind',
  'admin.responseSla.ruling.candidate': 'Candidate',
  'admin.responseSla.ruling.promisedBy': 'Promised by',
  'admin.responseSla.ruling.extendDays': 'Working days to extend',
  'admin.responseSla.ruling.blockerRef': 'Blocking ticket number',
  'admin.responseSla.ruling.reason': 'Reason (required)',
  'admin.responseSla.ruling.reasonHelper': 'The ruler\'s own words, at most 2000 bytes; it is archived with the reading into the acceptance minutes.',
  'admin.responseSla.ruling.noCandidate': 'This item has no selectable candidate (honoured / not honoured may only point at a candidate already ruled provisional).',
  'admin.responseSla.ruling.submit': 'Record ruling',
  'admin.responseSla.ruling.done': 'Ruling recorded (append-only: earlier rows stay as the ledger).',
  'admin.responseSla.err.RULE_VIOLATION': 'The server refused the ruling\'s shape (inapplicable fields must be absent; provisional needs a promised day; extend needs days and a blocker)',
  'admin.responseSla.err.NOT_FOUND': 'This item no longer exists (outside the window, or the database changed) - query again.',

  // SB-190 step 5 (batch 247): response SLA - the two label families SHARED by the member
  // faces and the admin page, plus the deadline bar. state / rule moved from
  // admin.responseSla.* to sla.*: the bar (ticket detail, message rows, forced-read gate,
  // the submit page's 201) and the admin page print the same verdict and the same rule, so
  // there is exactly one set of labels (pages/responseSla.mjs). Template keys are invisible
  // to keys.test; responseSla.test.mjs and adminResponseSla.test.mjs pin every value.
  'sla.state.on_time': 'on time',
  'sla.state.on_time_provisional': 'provisionally on time (within the promise)',
  'sla.state.late': 'late',
  'sla.state.needs_ruling': 'needs ruling',
  'sla.state.pending': 'within deadline',
  'sla.state.excluded': 'excluded',
  'sla.rule.1bd': 'same wall clock next working day',
  'sla.rule.1bd_shift': 'marked on a non-working day, from 00:00 of the next working day',
  'sla.rule.1bd_defer': '4th item of the day or later, one more working day',
  // The deadline bar: "Due … · rule 1bd_defer (item #4 of that day)" (design §8). The instant
  // is printed in the viewer's local time (fmtTime) with the calendar-zone SOP-11 frame as the
  // title; the rule is printed as its CODE with the sentence as the title.
  'sla.bar.due': 'Due {t}',
  'sla.bar.rule': 'rule {rule}',
  'sla.bar.rank': '(item #{n} of that day)',
  'sla.bar.extended': 'extended to {t}',
  'sla.bar.frozen': 'deadline frozen by a ruling',

  // H. Admin settings: requeueing failed jobs, and marking unwired operations.
  'admin.settings.jobs.requeue': 'Requeue',
  'admin.settings.jobs.requeueForce': 'Requeue anyway',
  'admin.settings.jobs.requeued': 'Queued a new job #{id}.',
  'admin.settings.jobs.failClass.transient': 'retryable',
  'admin.settings.jobs.failClass.permanent': 'retry futile',
  'admin.settings.jobs.failClass.account': 'account refusing',
  'admin.settings.jobs.failClass.unknown': 'reason unknown',
  'admin.settings.jobs.err.notTerminal': 'This job has not finished (queued or running), so there is nothing to requeue.',
  'admin.settings.jobs.err.futile': 'The request itself was rejected; an identical requeue will be rejected the same way. To try anyway, press "Requeue anyway".',
  'admin.settings.op.unwired': 'no caller',
  'admin.settings.op.unwiredHint': 'This entry is in the config table, but nothing in the repository calls it - changing it has no effect whatsoever. It is not "switched off": there is no switch to flip.',

  // ── SB-197 S3b (batch 292): asset ledger four-state records ────────────────
  'shell.nav.assetProgress': 'Asset ledger',
  'assetProgress.title': 'Art–program asset ledger · four states',
  'assetProgress.subtitle': 'Each cell is the latest record of that asset in that state (value · recorder · date · evidence). Recording needs evidence; the canon lives in the repository, the workspace pulls per batch and the ledger\'s §5 follows.',
  'assetProgress.role': 'This session records as: {role}',
  'assetProgress.roleNone': 'Read-only for this job post (cannot record)',
  'assetProgress.summary': '{rows} rows · {events} records',
  'assetProgress.sectionSummary': '{count} rows',
  'assetProgress.done': '{done} / {total} done',
  'assetProgress.rowsEmpty': 'No rows in the mirror — the ledger main table has not been pushed at deployment yet.',
  'assetProgress.col.ma': 'MA',
  'assetProgress.col.deliverer': 'Delivered by',
  'assetProgress.col.version': 'In use from',
  'assetProgress.col.history': 'History',
  'assetProgress.state.art_delivered': 'Art delivered',
  'assetProgress.state.program_received': 'Program received',
  'assetProgress.state.program_integrated': 'Program integrated',
  'assetProgress.state.screen_verified': 'Screen verified',
  'assetProgress.value.unknown': 'unknown',
  'assetProgress.value.not_started': 'not started',
  'assetProgress.value.partial': 'partial',
  'assetProgress.value.blocked': 'blocked',
  'assetProgress.value.pending_review': 'pending review',
  'assetProgress.value.done': 'done',
  'assetProgress.value.not_applicable': 'not applicable',
  'assetProgress.record': 'Record',
  'assetProgress.none': '—',
  'assetProgress.expandAll': 'Expand all',
  'assetProgress.collapseAll': 'Collapse all',
  'assetProgress.reload': 'Reload',
  'assetProgress.dialog.title': 'Record: {ma} · {state}',
  'assetProgress.dialog.chain': 'Follows #{id}',
  'assetProgress.dialog.chainFirst': 'First record for this cell',
  'assetProgress.dialog.value': 'Value',
  'assetProgress.dialog.evidence': 'Evidence (required: a ticket number, message id, screenshot path — something checkable)',
  'assetProgress.dialog.assetVersion': 'Asset version (e.g. art-v1)',
  'assetProgress.dialog.usage': 'Usage (after usage binding)',
  'assetProgress.dialog.note': 'Short note',
  'assetProgress.dialog.submit': 'Record',
  'assetProgress.evidenceRequired': 'A state without evidence is not a state — please give evidence.',
  'assetProgress.history.title': 'Records of {ma} (newest first)',
  'assetProgress.history.empty': 'No records yet.',
  'assetProgress.err.stale': 'Someone recorded in between; you were not chaining onto the latest — reloaded, please record again.',
  'assetProgress.err.forbidden': 'This job post may not record that state.',
  'assetProgress.err.rule': 'The server refused this record (shape, enum, evidence, or the MA is not in the mirror).',
  'assetProgress.err.notFound': 'This group has no published ledger page, or this job post cannot see it.',
  'assetProgress.err.failed': 'Recording failed, please retry.',
  // batch 294 (owner's instruction): the MA opens the asset's detail
  'assetProgress.detail.title': '{ma} asset detail',
  'assetProgress.detail.empty': 'The mirror holds no detail for this row (the ledger has no detail block, or it has not been pushed at deployment yet).',
  'assetProgress.col.field': 'Field',
  'assetProgress.col.value': 'Value',
  'assetProgress.col.purpose': 'Purpose',
  'assetProgress.usage.unbound': '(no usage binding)',

  // ── SB-201 S3 (batch 308, owner's instruction "a tab like the asset ledger"): feature readiness three-state records ──
  'shell.nav.featureProgress': 'Feature ledger',
  'featureProgress.title': 'Feature-code readiness · three states',
  'featureProgress.subtitle': 'Each cell is the latest record of that feature point in that state (value · recorder · date · evidence). "Implemented" and "passed" need evidence, ideally a git commit; the canon lives in the repository, the workspace pulls per batch and the feature table follows.',
  'featureProgress.role': 'This session records as: {role}',
  'featureProgress.roleNone': 'Read-only for this job post (cannot record)',
  'featureProgress.summary': '{rows} feature points · {events} records',
  'featureProgress.sectionSummary': '{count} nodes ({parents} parents / {children} children)',
  // batch 313 (S4): second-level expand — a parent is a node of its own, never derived from its children; parents and children count equally in the denominator
  'featureProgress.childrenOpen': 'Show {n} sub-items',
  'featureProgress.childrenClose': 'Hide sub-items',
  'featureProgress.done': '{done} / {total}',
  'featureProgress.rowsEmpty': 'No rows in the mirror — the feature table has not been pushed at deployment yet.',
  'featureProgress.col.fp': 'FP',
  'featureProgress.col.sentence': 'Feature point',
  'featureProgress.col.source': 'Spec source',
  'featureProgress.col.owner': 'Owner post',
  'featureProgress.col.history': 'History',
  'featureProgress.state.implemented': 'Implemented',
  'featureProgress.state.self_tested': 'Self-tested',
  'featureProgress.state.qa_passed': 'QA',
  'featureProgress.value.not_started': 'not started',
  'featureProgress.value.partial': 'partial',
  'featureProgress.value.done': 'implemented',
  'featureProgress.value.none': 'none',
  'featureProgress.value.passed': 'passed',
  'featureProgress.record': 'Record',
  'featureProgress.none': '—',
  'featureProgress.expandAll': 'Expand all',
  'featureProgress.collapseAll': 'Collapse all',
  'featureProgress.reload': 'Reload',
  'featureProgress.dialog.title': 'Record: {fp} · {state}',
  'featureProgress.dialog.chain': 'Follows #{id}',
  'featureProgress.dialog.chainFirst': 'First record for this cell',
  'featureProgress.dialog.value': 'Value',
  'featureProgress.dialog.evidence': 'Evidence (required: a git commit sha or PR; else a ticket number or message id — something checkable)',
  'featureProgress.dialog.evidenceOptional': 'Evidence (optional)',
  'featureProgress.dialog.evidenceHint': 'This does not look like a git commit (no sha / PR) — you may record it, but please anchor to a commit where possible.',
  'featureProgress.dialog.note': 'Short note',
  'featureProgress.dialog.submit': 'Record',
  'featureProgress.evidenceRequired': '"Implemented" and "passed" do not count without evidence — give a git commit or other checkable evidence.',
  'featureProgress.history.title': 'Records of {fp} (newest first)',
  'featureProgress.history.empty': 'No records yet.',
  'featureProgress.err.stale': 'Someone recorded in between; you were not chaining onto the latest — reloaded, please record again.',
  'featureProgress.err.forbidden': 'This job post may not record that state.',
  'featureProgress.err.rule': 'The server refused this record (shape, enum, evidence, or the FP is not in the mirror).',
  'featureProgress.err.notFound': 'This group has no published feature table page, or this job post cannot see it.',
  'featureProgress.err.failed': 'Recording failed, please retry.',
  // ── SB-159 (batch 382): list paging — "this page holds N" must be tellable from "there are N" ──
  // Review: the three load-outcome sentences carry a per-page prefix (pagingNotice's ns) — the noun and any
  // "Retry fixes it" promise only hold for one page.
  'approvals.total': '{n} listed in this view',
  'approvals.paging.capped': 'Only the first {n} tickets are listed (the server counts {total}) — the page limit for one load was reached; narrow the filters.',
  'approvals.paging.maybeMore': 'Listed {n} tickets, but the server did not say whether there are more (older server) — this list may be incomplete.',
  'approvals.paging.drift': 'Fetched {n} tickets, but the server counts {total} — the list changed while loading, or part of it was not fetched. Retry to reload it in full.',
  'tickets.paging.drift': 'Listed {n} tickets here, but the server counts {total} — this list is incomplete. If tickets were added or changed while it loaded, Retry fills it in; if the server now caps this page, retrying will not bring the rest back — tell an admin.',
  'paging.hasMore': 'There are more not listed here (this page holds at most {n}).',
  'notif.loadMore': 'Load more (older notifications)',
  'notif.loadMoreBusy': 'Fetching…',
  'notif.loadMoreError': 'This page did not come back — not "no more", just not fetched. Click again to retry.',
  'notif.unreadOutside': '{n} more unread not shown above — use "Load more" to page back.',
  // Shown when there is no "Load more" (older server, the server says no more, or the poll raised the badge while
  // the menu was open — the missing ones are newer, not older).
  'notif.unreadOutsideReopen': '{n} more unread not shown above — reopen the bell to refresh.',
  'pager.prev': 'Previous',
  'pager.next': 'Next',
  'admin.escalations.range': 'Rows {from}–{to} of {total}',
  'admin.escalations.unacked': '{n} open in total',
  'admin.repos.branchesTruncated': 'Too many branches: the list shows {n} of the {total} in this repository; the branch you want may not be in it.',
  'admin.repos.defaultBranchNotListed': 'Neither main nor master is among the listed branches; it may be in the part that was not listed. Showing {name}, which is not the default branch.',
  'admin.repos.noDefaultBranch': 'This repository has no main or master branch; showing the first branch, {name}.',
  'admin.escalations.totalUnknown': 'The server gave no total (older server) — there may be more than the {n} listed here; do not read this as all of them.',
  'admin.readAudit.limitReached': 'The {n}-row cap was reached: the oldest row on this page is at {oldest}, and earlier records are not listed — move "To" before that moment and query again.',
  'admin.readAudit.pageOnly': ' (this page only)',
  'due.loadFailed': 'The due actions did not load — that is not the same as "nothing is due". Retry to fetch them again.',
  'work.backlogsLoadFailed': 'The work-item list did not load — that is not the same as "nothing to log against". Reload the page and try again.',
};
